<template>
  <!-- 最顶部title -->
  <div class="liu pos-manage">
    <mt-header fixed title="新增进件" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" v-if="!flow.finished" :style="customScrollHeight">
      <!-- 上部tab菜单 -->
      <div class="tab-menu">
        <div class="tab-menu-item" :class="{'selected': tabStatus.selected[0], 'complete': tabStatus.completed[0]}" @click="onTabClick(0)">
          <span>设置费率</span>
        </div>
        <div class="tab-menu-item" :class="{'selected': tabStatus.selected[1], 'complete': tabStatus.completed[1]}" @click="onTabClick(1)">
          <span>公司资料</span>
        </div>
        <div class="tab-menu-item" :class="{'selected': tabStatus.selected[2], 'complete': tabStatus.completed[2]}" @click="onTabClick(2)">
          <span>法人资料</span>
        </div>
        <div class="tab-menu-item" :class="{'selected': tabStatus.selected[3], 'complete': tabStatus.completed[3]}" @click="onTabClick(3)">
          <span>收款资料</span>
        </div>
        <div class="tab-menu-item" :class="{'selected': tabStatus.selected[4], 'complete': tabStatus.completed[4]}" @click="onTabClick(4)">
          <span>协议授权</span>
        </div>
      </div>
      <!-- 费率信息-主体 -->
      <div id="tabItem0" v-show="currentTabIndex === 0">
        <div class="form mt-53">
          <!-- 费率(万分之) -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ rateData.normalRate.label }}</span>
              </div>
              <div class="content">
                <input type="text" class="rate-text" v-model="rateData.normalRate.value" maxlength="10" :placeholder="rateData.normalRate.placeholder" @keyup="onNormalRateInput">
              </div>
            </div>
          </div>
          <!-- 手续费(元/笔) -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ rateData.normalCost.label }}</span>
              </div>
              <div class="content tar">
                <span> {{ rateData.normalCost.value }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onRatePageSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!-- 公司信息-主体 -->
      <div id="tabItem1" v-show="currentTabIndex === 1">
        <div class="form mt-53">
          <!-- 证件照类型 -->
          <div class="row" v-if="currentIntoType==0" @click="onLicenseTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licenseType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.licenseType.value!=='请选择'}">
                <span>{{ companyData.licenseType.value }}</span>
                <div class="arrow" v-show="companyData.licenseType.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 营业执照照片 -->
          <div class="row" v-if="currentIntoType==0">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licensePicture.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('licensePicture')">
                  <svg-icon v-if="!companyData.licensePicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="companyData.licensePicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 店铺门头照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ companyData.shopPicture.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('shopPicture')">
                  <svg-icon v-if="!companyData.shopPicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="companyData.shopPicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 经营场所照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ companyData.placePicture.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('placePicture')">
                  <svg-icon v-if="!companyData.placePicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="companyData.placePicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 收银台照片 -->
          <div class="row">
            <div class="item">
              <div class="label" style="padding-right:0.85rem;">
                <span>{{ companyData.cashierPicture.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('cashierPicture')">
                  <svg-icon v-if="!companyData.cashierPicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="companyData.cashierPicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <div class="title">
            <span>上传其它照片(选填)</span>
          </div>
          <!-- 其它照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>请选择</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('other1Picture')">
                      <img v-if="companyData.other1Picture.value" :src="companyData.other1Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('other2Picture')">
                      <img v-if="companyData.other2Picture.value" :src="companyData.other2Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 营业执照类型 -->
          <div class="row" v-if="currentIntoType==0" @click="onBusinessLicenseTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.businessLicenseType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.businessLicenseType.value!=='请选择'}">
                <span>{{ companyData.businessLicenseType.value }}</span>
                <div class="arrow" v-show="companyData.businessLicenseType.mult" />
              </div>
            </div>
          </div>
          <!-- 营业执照注册号 -->
          <div class="row" v-if="currentIntoType==0">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licenseNumber.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.licenseNumber.value" maxlength="18" :placeholder="companyData.licenseNumber.placeholder" @keyup="onLicenseNumberInput">
              </div>
            </div>
          </div>
          <!-- 公司名称 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.companyName.value" :placeholder="companyData.companyName.placeholder" @keyup="onCompanyNameInput">
              </div>
            </div>
          </div>
          <!-- 公司简称 2022.8.18 -->
          <div class="row" v-if="tmp.isNeedShort">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyShortName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.companyShortName.value" :placeholder="companyData.companyShortName.placeholder" @keyup="onCompanyShortNameInput">
              </div>
            </div>
          </div>
          <!-- 详细地址 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyAddress.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.companyAddress.value" :placeholder="companyData.companyAddress.placeholder">
              </div>
            </div>
          </div>
          <!-- 营业执照生效日期 -->
          <div class="row" v-if="currentIntoType==0" @click="onDatePickerItemClick('licenceStartDate')">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licenceStartDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.licenceStartDate.value!=='请选择'}">
                <span>{{ companyData.licenceStartDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 营业执照有效期 -->
          <div class="row" v-if="currentIntoType==0" @click="onDatePickerItemClick('licenseValidDate')">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licenseValidDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.licenseValidDate.value!=='请选择'}">
                <span class="link" @click.stop="onLicenseValidDateBtnClick">长期</span>
                <span>{{ companyData.licenseValidDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 店铺经营范围 -->
          <div class="row" v-if="currentIntoType==0">
            <div class="item">
              <div class="label">
                <span>{{ companyData.licenseScope.label }}</span>
              </div>
              <div class="content">
                <textarea v-model="companyData.licenseScope.value" :placeholder="companyData.licenseScope.placeholder" />
              </div>
            </div>
          </div>
          <!-- 所属行业 -->
          <div class="row" @click="onTradeTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.tradeType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.tradeType.value!=='请选择'}">
                <span>{{ companyData.tradeType.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 所在省份 -->
          <div class="row" @click="onCompanyProvinceCItyAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyProvince.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.companyProvince.value!=='请选择'}">
                <span>{{ companyData.companyProvince.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 所在城市 -->
          <div class="row" @click="onCompanyProvinceCItyAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyCity.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.companyCity.value!=='请选择'}">
                <span>{{ companyData.companyCity.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 所在地区 -->
          <div class="row" @click="onCompanyProvinceCItyAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyArea.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':companyData.companyArea.value!=='请选择'}">
                <span>{{ companyData.companyArea.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 公司经营名称(选填) -->
          <div class="row" v-if="currentIntoType==0">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyLicenseName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.companyLicenseName.value" :placeholder="companyData.companyLicenseName.placeholder">
              </div>
            </div>
          </div>
          <!-- 公司英文名称(选填) -->
          <div class="row" v-if="currentIntoType==0">
            <div class="item">
              <div class="label">
                <span>{{ companyData.companyEnglishName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="companyData.companyEnglishName.value" :placeholder="companyData.companyEnglishName.placeholder">
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onCompanyPageSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!-- 法人信息-主体 -->
      <div id="tabItem2" v-show="currentTabIndex === 2">
        <div class="form mt-53">
          <!-- 法人证件类型 -->
          <div class="row" @click="onIdentityTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.identityType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':corporationData.identityType.value!=='请选择'}">
                <span>{{ corporationData.identityType.value }}</span>
                <div class="arrow" v-show="corporationData.identityType.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 法人证件照 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>证件照</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('renXiang')">
                      <img v-if="corporationData.identityCardPictureFront.value" :src="corporationData.identityCardPictureFront.value" alt="">
                      <svg-icon v-else icon-class="authenticate-headshot" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ corporationData.identityCardPictureFront.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('guoHui')">
                      <img v-if="corporationData.identityCardPictureBack.value" :src="corporationData.identityCardPictureBack.value" alt="">
                      <svg-icon v-else icon-class="authenticate-emblem" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ corporationData.identityCardPictureBack.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 法人姓名 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.corporationName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="corporationData.corporationName.value" maxlength="15" :placeholder="corporationData.corporationName.placeholder">
              </div>
            </div>
          </div>
          <!-- 证件号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.identityCardNumber.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="corporationData.identityCardNumber.value" maxlength="20" :placeholder="corporationData.identityCardNumber.placeholder" @keyup="onIdentityCardNumberInput">
              </div>
            </div>
          </div>
          <!-- 证件有效开始日期 -->
          <div class="row" @click="onDatePickerItemClick('identityCardStartDate')">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.identityCardStartDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':corporationData.identityCardStartDate.value!=='请选择'}">
                <span>{{ corporationData.identityCardStartDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 证件有效截止日期 -->
          <div class="row" @click="onDatePickerItemClick('identityCardEndDate')">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.identityCardEndDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':corporationData.identityCardEndDate.value!=='请选择'}">
                <span class="link" @click.stop="onIdCardEndDateBtnClick">长期</span>
                <span>{{ corporationData.identityCardEndDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 法人手机号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ corporationData.corporationMobile.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="corporationData.corporationMobile.value" maxlength="13" :placeholder="corporationData.corporationMobile.placeholder" @keyup="onCorporationMobileInput">
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onCorporationPageSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!-- 银行卡信息-主体 -->
      <div id="tabItem3" v-show="currentTabIndex === 3">
        <div class="form mt-53">
          <!-- 收款方式 -->
          <div class="row" @click="onBankCardTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankCardType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.bankCardType.value!=='请选择'}">
                <span>{{ bankCardData.bankCardType.value }}</span>
                <div class="arrow" v-show="bankCardData.bankCardType.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15" v-show="bankCardData.bankCardType.id === 0 || bankCardData.bankCardType.id === 1">
          <div class="title">
            <span>法人银行卡信息</span>
          </div>
          <!-- 银行卡照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankCardPicture.label }}</span>
              </div>
              <div class="content ">
                <div class="picture" @click="$refs.camera.imgClick('bankCardPicture')">
                  <svg-icon v-if="!bankCardData.bankCardPicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="bankCardData.bankCardPicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 开户姓名 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.accountName.label }}</span>
              </div>
              <div class="content">
                <span>{{ bankCardData.accountName.value }}</span>
              </div>
            </div>
          </div>
          <!-- 银行卡号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankCardNumber.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.bankCardNumber.value" maxlength="23" :placeholder="bankCardData.bankCardNumber.placeholder" @keyup="onBankCardNumberInput">
              </div>
            </div>
          </div>
          <!-- 所属银行 -->
          <div class="row" @click="onBankNameClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.bankName.value!=='请选择'}">
                <span>{{ bankCardData.bankName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 开户地区 -->
          <div class="row" @click="onBankAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankArea.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.bankArea.value!=='请选择'}">
                <span>{{ bankCardData.bankArea.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 开户行 -->
          <div class="row" @click="onBankSubNameClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.bankSubName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.bankSubName.value!=='请选择'}">
                <span>{{ bankCardData.bankSubName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 预留手机号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.accountMobile.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.accountMobile.value" maxlength="13" :placeholder="bankCardData.accountMobile.placeholder" @keyup="onAccountMobileInput">
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15" v-show="bankCardData.bankCardType.id === 1">
          <div class="title">
            <span>被授权人证件信息</span>
          </div>
          <!-- 被授权人证件照 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>证件照</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('grantRenXiang')">
                      <img v-if="bankCardData.grantIdCardPictureFront.value" :src="bankCardData.grantIdCardPictureFront.value" alt="">
                      <svg-icon v-else icon-class="authenticate-headshot" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ bankCardData.grantIdCardPictureFront.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('grantGuoHui')">
                      <img v-if="bankCardData.grantIdCardPictureBack.value" :src="bankCardData.grantIdCardPictureBack.value" alt="">
                      <svg-icon v-else icon-class="authenticate-emblem" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ bankCardData.grantIdCardPictureBack.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 被授权人姓名 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantCorporationName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.grantCorporationName.value" maxlength="15" :placeholder="bankCardData.grantCorporationName.placeholder">
              </div>
            </div>
          </div>
          <!-- 被授权人证件号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantIdCardNumber.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.grantIdCardNumber.value" maxlength="20" :placeholder="bankCardData.grantIdCardNumber.placeholder" @keyup="onGrantIdCardNumberInput">
              </div>
            </div>
          </div>
          <!-- 被授权人住址 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantIdCardAddress.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.grantIdCardAddress.value" :placeholder="bankCardData.grantIdCardAddress.placeholder">
              </div>
            </div>
          </div>
          <!-- 被授权人证件有效开始日期 -->
          <div class="row" @click="onDatePickerItemClick('grantIdCardStartDate')">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantIdCardStartDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.grantIdCardStartDate.value!=='请选择'}">
                <span>{{ bankCardData.grantIdCardStartDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 被授权人证件有效截止日期 -->
          <div class="row" @click="onDatePickerItemClick('grantIdCardEndDate')">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantIdCardEndDate.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.grantIdCardEndDate.value!=='请选择'}">
                <span class="link" @click.stop="onGrantIdCardEndDateBtnClick">长期</span>
                <span>{{ bankCardData.grantIdCardEndDate.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15" v-show="bankCardData.bankCardType.id === 1">
          <div class="title">
            <span>被授权人银行卡信息</span>
          </div>
          <!-- 被授权人银行卡照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantBankCardPicture.label }}</span>
              </div>
              <div class="content ">
                <div class="picture" @click="$refs.camera.imgClick('grantBankCardPicture')">
                  <svg-icon v-if="!bankCardData.grantBankCardPicture.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="bankCardData.grantBankCardPicture.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 被授权人银行卡号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantBankCardNumber.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.grantBankCardNumber.value" maxlength="23" :placeholder="bankCardData.grantBankCardNumber.placeholder" @keyup="onGrantBankCardNumberInput">
              </div>
            </div>
          </div>
          <!-- 被授权银行卡所属银行 -->
          <div class="row" @click="onGrantBankNameClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantBankName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.grantBankName.value!=='请选择'}">
                <span>{{ bankCardData.grantBankName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 被授权银行卡开户地区 -->
          <div class="row" @click="onGrantBankAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantBankArea.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.grantBankArea.value!=='请选择'}">
                <span>{{ bankCardData.grantBankArea.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 被授权银行卡开户行 -->
          <div class="row" @click="onGrantBankSubNameClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantBankSubName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.grantBankSubName.value!=='请选择'}">
                <span>{{ bankCardData.grantBankSubName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 被授权人预留手机号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.grantAccountMobile.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="bankCardData.grantAccountMobile.value" maxlength="13" :placeholder="bankCardData.grantAccountMobile.placeholder" @keyup="onGrantAccountMobileInput">
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 营业周期 -->
          <div class="row" @click="onBusinessCycleClick">
            <div class="item">
              <div class="label">
                <span>{{ bankCardData.businessCycle.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':bankCardData.businessCycle.value!=='请选择'}">
                <span>{{ bankCardData.businessCycle.value }}</span>
                <div class="arrow" v-show="bankCardData.businessCycle.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onBankCardPageSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!--授权协议-主体 -->
      <div id="tabItem4" v-show="currentTabIndex === 4">
        <div class="form mt-53">
          <!-- 协议类型 -->
          <div class="row" @click="onAgreementTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ commitmentData.agreementType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':commitmentData.agreementType.value!=='请选择'}">
                <span>{{ commitmentData.agreementType.value }}</span>
                <div class="arrow" v-show="commitmentData.agreementType.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15" v-if="commitmentData.agreementType.id===1">
          <div class="title">
            <span>协议信息</span>
          </div>
          <!-- 协议照片1 -->
          <div class="row" v-if="agreementPageCount >= 2">
            <div class="item">
              <div class="label">
                <span>上传1/2页</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile1')">
                      <img v-if="commitmentData.agreementFile1Picture.value" :src="commitmentData.agreementFile1Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile1Picture.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile2')">
                      <img v-if="commitmentData.agreementFile2Picture.value" :src="commitmentData.agreementFile2Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile2Picture.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 协议照片2 -->
          <div class="row" v-if="agreementPageCount >= 4">
            <div class="item">
              <div class="label">
                <span>上传3/4页</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile3')">
                      <img v-if="commitmentData.agreementFile3Picture.value" :src="commitmentData.agreementFile3Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile3Picture.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile4')">
                      <img v-if="commitmentData.agreementFile4Picture.value" :src="commitmentData.agreementFile4Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile4Picture.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 协议照片3 -->
          <div class="row" v-if=" agreementPageCount>= 6">
            <div class="item">
              <div class="label">
                <span>上传5/6页</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile5')">
                      <img v-if="commitmentData.agreementFile5Picture.value" :src="commitmentData.agreementFile5Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile5Picture.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('agreementFile6')">
                      <img v-if="commitmentData.agreementFile6Picture.value" :src="commitmentData.agreementFile6Picture.value" alt="">
                      <svg-icon v-else icon-class="camera_comm" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ commitmentData.agreementFile6Picture.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15" v-if="commitmentData.agreementType.id===1">
          <!-- 承诺函 -->
          <div class="title">
            <span>承诺函信息</span>
          </div>
          <div class="row">
            <div class="item">
              <div class="label">
                <div class="word">
                  <div class="word-title">
                    <span>承诺函</span>
                  </div>
                  <div class="word-content">
                    <span>
                      我司承诺已全部阅读及充分理解我司与易付通签署<span class="red">《特约商户受理银行卡协议书》</span>(协议编号：{{ commitmentData.commitmentNumber.value }})的各项条款,并愿意遵守该协议的各项规定，我司确认本承诺函的签署自愿、真实、合法、有效不存在任何虚假。
                    </span>
                  </div>
                  <div class="word-content">
                    <span>
                      本承诺函扫描件与原件具有同等法律效力。
                    </span>
                  </div>
                  <div class="word-date">
                    <span>
                      法人(签字并加盖公章)<br />日期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;月&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="explain" v-if="commitmentData.agreementType.id===1">
          <span>
            请手动抄写或打印以上文字，法人需要盖章，个体工商户需要签字加按手印，完成后点击拍照上传。
          </span>
        </div>
        <div class="form" v-if="commitmentData.agreementType.id===1">
          <!-- 承诺函照片 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ commitmentData.commitmentPicture.label }}</span>
              </div>
              <div class="content ">
                <div class="picture" @click="$refs.camera.imgClick('commitmentPicture')">
                  <img v-if="commitmentData.commitmentPicture.value" :src="commitmentData.commitmentPicture.value" alt="">
                  <svg-icon v-else icon-class="camera_comm" class-name="svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onCommitmentPageSubmitClick">
            提交
          </mt-button>
        </div>
      </div>
    </div>
    <!-- 副页面：提示等待审核 - 企业营业执照进件 -->
    <div class="scroll-container" v-if="currentIntoType===0 && flow.finished" :style="customScrollHeight">
      <div class="big-picture" :class="{'mult':!routeQueryId && agreement.type===0 && agreement.step===4}">
        <svg-icon icon-class="business_success" class-name="svg" />
        <span v-if="routeQueryId">商户信息已提交，请耐心等待后台审核</span>
        <span v-if="!routeQueryId && agreement.type===1">商户信息已提交，请耐心等待后台审核</span>
        <span v-if="!routeQueryId && agreement.type===0 && agreement.step!==4">商户信息已提交<br>请点击按钮发起电子协议签署流程</span>
        <span v-if="!routeQueryId && agreement.type===0 && agreement.step===4">商户信息已提交，所生成的电子协议网址已通过手机短信发送至号码为 <span class="tips">{{ agreement.mobile }}</span> 的手机中，请及时查阅并签署协议</span>
      </div>
      <div class="btn" v-if="routeQueryId || !routeQueryId && agreement.type===1 || !routeQueryId && agreement.type===0 && agreement.step===4">
        <mt-button type="primary" size="large" @click="onFlowFinishBtnClick">
          确定
        </mt-button>
      </div>
      <div class="btn" v-if="!routeQueryId && agreement.type===0 && agreement.step!==4">
        <mt-button type="primary" size="large" @click="onAgreementFlowStartBtnClick">
          发起电子协议签署流程
        </mt-button>
      </div>
    </div>
    <!-- 副页面：提示等待审核 - 小微商户进件 -->
    <div class="scroll-container" v-if="currentIntoType===1 && flow.finished" :style="customScrollHeight">
      <div class="big-picture mult">
        <svg-icon icon-class="business_success" class-name="svg" />
        <span>商户信息已提交， 请复制<span class="tips">{{ tmp.xwFaceUrl }}</span> 此URL并发送给商户进行商户认证</span>
      </div>
      <div class="btn">
        <mt-button type="primary" size="large" v-clipboard:copy="tmp.xwFaceUrl" v-clipboard:success="onClipboardSuccess" v-clipboard:error="onClipboardError">
          复制当前URL内容
        </mt-button>
      </div>
    </div>
    <!-- 页面右侧备选项窗口 -->
    <mt-popup class="agent-popup" v-model="popup.visible" position="right" :modal="false">
      <mt-header fixed :title="popup.title" class="title2">
        <mt-button slot="left" icon="back" @click="onPopupBackBtnClick">返回</mt-button>
      </mt-header>
      <div class="scroll-container" :style="customScrollHeight">
        <!-- 短备选项 -->
        <div class="mt-15" v-if="popup.type===1">
          <!-- 营业执照类型 -->
          <div class="form" v-if="popup.parent==='businessLicenseType'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.businessLicenseTypeArr" :key="idx" @click="onBusinessLicenseTypeItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款方式 -->
          <div class="form" v-if="popup.parent==='bankCardType'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankCardTypeArr" :key="idx" @click="onBankCardTypeItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 协议类型 -->
          <div class="form" v-if="popup.parent==='agreementType'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.agreementTypeArr" :key="idx" @click="onAgreementTypeItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn">
            <mt-button type="primary" size="large" @click="onPopupSuccessBtnClick">
              确定
            </mt-button>
          </div>
        </div>
        <!-- 长备选项 -->
        <mt-search ref="searchBar" v-show="popup.type===2" v-model="popup.searchKey" cancel-text="查询" placeholder="筛选" :show="true" @keyup.enter.native="onPopupSearchKeyup">
          <!-- 所属行业分类 -->
          <div v-if="popup.parent==='tradeType'">
            <el-collapse v-model="popup.businessOpened">
              <el-collapse-item v-for="(item,idx) in popup.businessAllArr" :key="idx" :name="item.itemName">
                <template slot="title">
                  <div>
                    <span>{{ item.businessLabel }}</span>
                  </div>
                </template>
                <div v-for="(subItem,subIdx) in item.subBusinessArr" :key="subIdx">
                  <div class="trade-type-row" @click="onPopupSubTradeTypeItemClick(subItem)">
                    <span>{{ subItem.businessLabel }}</span>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- 收款资料-银行卡银行 -->
          <div class="form" v-if="popup.parent==='bankName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankNameArr" :key="idx" @click="onPopupBankNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-银行卡地区 -->
          <div class="form" v-if="popup.parent==='bankArea'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankAreaArr" :key="idx" @click="onPopupBankAreaItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" style="right:1.6rem;" />
                  <div class="arrow" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-银行卡开户行 -->
          <div class="form" v-if="popup.parent==='bankSubName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankSubNameArr" :key="idx" @click="onPopupBankSubNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-被授权银行卡银行 -->
          <div class="form" v-if="popup.parent==='grantBankName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.grantBankNameArr" :key="idx" @click="onPopupGrantBankNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-被授权银行卡地区 -->
          <div class="form" v-if="popup.parent==='grantBankArea'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.grantBankAreaArr" :key="idx" @click="onPopupGrantBankAreaItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" style="right:1.6rem;" />
                  <div class="arrow" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-被授权银行卡开户行 -->
          <div class="form" v-if="popup.parent==='grantBankSubName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.grantBankSubNameArr" :key="idx" @click="onPopupGrantBankSubNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
        </mt-search>
        <mt-search ref="searchSubBar" v-show="popup.type===3" v-model="popup.searchSubKey" cancel-text="查询" placeholder="筛选" :show="true" @keyup.enter.native="onPopupSearchSubKeyup">
          <!-- 收款资料-银行卡地区城市 -->
          <div class="form" v-if="popup.parent==='bankAreaProvince'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankAreaCityArr" :key="idx" @click="onPopupBankAreaCityItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-被授权银行卡地区城市 -->
          <div class="form" v-if="popup.parent==='grantBankAreaProvince'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.grantBankAreaCityArr" :key="idx" @click="onPopupGrantBankAreaCityItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
        </mt-search>
      </div>
    </mt-popup>
    <!-- 页面下侧省市区窗口 -->
    <mt-popup class="area-popup" v-model="areaPop.visible" position="bottom" :modal="true">
      <mt-picker :slots="areaPop.areaSlots" valueKey="label" :visibleItemCount="5" :showToolbar="true" @change="onAreaPopChange">
        <div class="tool-bar">
          <div class="tool-btn" @click="areaPop.visible=false">
            <span>关闭</span>
          </div>
          <div class="tool-btn" :class="{'disable': tmp.isAreaFinish===false}" @click="onAreaPopupSuccessClick">
            <span>确定</span>
          </div>
        </div>
      </mt-picker>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
    <!-- 相机组件 -->
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
  </div>
</template>

<script>
/*global PUBLIC_AGREEMENT_PAGE_COUNT */
/*global PUBLIC_XW_COMPANY_MIN */

import {
  GetAreaList,
  GetCurrentAgentFee,
  GetIdCardInformation,
  GetBankCardInformation,
  GetAllBankName,
  GetBankProvinceName,
  GetBankCityName,
  GetBankName,
  InsertNewCustomerData,
  EditCustomerData,
  GetSBNOByCardNum,
  GetBusinessLicenseInfo,
  GenerateAuthNum,
  ResendEAgreement,
  InsertCustomerCache,
  GetCustomerCache,
  QueryBlacklist,
  IsReachedMaximumLimitByIdCardNum,
  IsLegitimacyForCompanyName,
  BusinessStartDateParse,
  IsLegitimacyForCompanyArea,
  IsLegitimacyForCompanyAddress,
} from '@/api/customer';
import {
  formatRateForShow,
  formatRateForSubmit,
  formatMoneyToYuan,
  formatLicenseDate,
  controlRateInput,
  controlIdCardInput,
  controlMobileInput,
  controlBankCardInput,
  controlLicenseNoInput,
  controlCompanyNameInput,
} from '@/utils/format';
import { validateEmpty, validateRate, validateMobile, validateIdCard, validateBankCard, validateMinMax, validateLicenseNo2, validateXwCompanyName } from '@/utils/validate';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { upLoadImgForAgent, formatDateId } from '@/utils/utils';
import { CusToast, CusAlert, CusConfirm, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import camera from '@/components/camera';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'PosManageEdit',
  components: { camera, SvgIcon },
  data() {
    return {
      currentIntoType: 0, // 0营业执照项  1小微商户项
      currentTabIndex: 0,
      isFlowFinish: true,
      tabStatus: {
        selected: [true, false, false, false, false],
        edited: [true, false, false, false, false],
        completed: [false, false, false, false, false],
      },
      rateData: {
        normalRate: { label: '费率(万分之)', value: '', placeholder: '' },
        normalCost: { label: '手续费(万分之)', value: '2', placeholder: '' },
      },
      companyData: {
        licenseType: { label: '证件照类型', value: '营业执照', id: 1, placeholder: '', mult: false },
        licensePicture: { label: '营业执照照片', value: '', placeholder: '' },
        shopPicture: { label: '店铺门头照片', value: '', placeholder: '' },
        placePicture: { label: '经营场所照片', value: '', placeholder: '' },
        cashierPicture: { label: '收银台照片', value: '', placeholder: '' },
        other1Picture: { label: '其它照片1(选填)', value: '', placeholder: '' },
        other2Picture: { label: '其它照片2(选填)', value: '', placeholder: '' },
        tradeType: { label: '所属行业', value: '请选择', id: '', placeholder: '' },
        businessLicenseType: { label: '营业执照类型', value: '请选择', id: 0, placeholder: '', mult: true },
        licenseScope: { label: '店铺经营范围', value: '', placeholder: '请输入店铺经营范围' },
        licenseNumber: { label: '营业执照注册号', value: '', person: '', placeholder: '请输入营业执照注册号' },
        licenceStartDate: { label: '营业执照生效日期', value: '请选择', placeholder: '' },
        licenseValidDate: { label: '营业执照有效期', value: '请选择', placeholder: '' },
        companyName: { label: '公司名称', value: '', placeholder: '请输入公司名称' },
        companyShortName: { label: '公司简称', value: '', placeholder: '请输入公司简称' }, // 2022.8.18
        companyLicenseName: { label: '公司经营名称(选填)', value: '', placeholder: '请输入公司经营名称' },
        companyEnglishName: { label: '公司英文名称(选填)', value: '', placeholder: '请输入公司英文名称' },
        companyProvince: { label: '所在省份', value: '请选择', id: '', placeholder: '' },
        companyCity: { label: '所在城市', value: '请选择', id: '', placeholder: '' },
        companyArea: { label: '所在地区', value: '请选择', id: '', placeholder: '' },
        companyAddress: { label: '详细地址', value: '', placeholder: '请输入详细地址' },
      },
      corporationData: {
        identityType: { label: '法人证件类型', value: '身份证', placeholder: '', mult: false },
        identityCardPictureFront: { label: '头像面', value: '', placeholder: '' },
        identityCardPictureBack: { label: '国徽面', value: '', placeholder: '' },
        corporationName: { label: '法人姓名', value: '', sex: '', birthday: '', nationality: '', address: '', office: '', placeholder: '请输入法人姓名' },
        identityCardNumber: { label: '证件号', value: '', placeholder: '请输入证件号' },
        identityCardStartDate: { label: '证件有效开始日期', value: '请选择', placeholder: '' },
        identityCardEndDate: { label: '证件有效截止日期', value: '请选择', placeholder: '' },
        corporationMobile: { label: '法人手机号', value: '', placeholder: '请输入法人手机号' },
        liaisonName: { label: '联系人姓名', value: '', placeholder: '请输入联系人姓名' },
        liaisonIdentityCardNo: { label: '联系人身份证号', value: '', placeholder: '请输入联系人身份证号' },
        liaisonMobile: { label: '联系人手机号', value: '', placeholder: '请输入联系人手机号' },
      },
      bankCardData: {
        bankCardType: { label: '收款方式', value: '法人收款', id: 0, placeholder: '', mult: true },
        bankCardPicture: { label: '银行卡照片', value: '', placeholder: '' },
        accountName: { label: '开户姓名', value: '', placeholder: '请输入开户姓名' },
        bankCardNumber: { label: '银行卡号', value: '', type: '', placeholder: '请输入银行卡号' },
        bankName: { label: '所属银行', value: '请选择', placeholder: '' },
        bankArea: { label: '开户地区', value: '请选择', placeholder: '' },
        bankSubName: { label: '开户行', value: '请选择', sbno: '', placeholder: '' },
        accountMobile: { label: '预留手机号', value: '', placeholder: '请输入预留手机号' },
        grantIdCardPictureFront: { label: '头像面', value: '', placeholder: '' },
        grantIdCardPictureBack: { label: '国徽面', value: '', placeholder: '' },
        grantCorporationName: { label: '被授权人姓名', value: '', sex: '', birthday: '', nationality: '', address: '', office: '', placeholder: '请输入法人姓名' },
        grantIdCardNumber: { label: '证件号', value: '', placeholder: '请输入证件号' },
        grantIdCardAddress: { label: '住址', value: '', placeholder: '请输入住址' },
        grantIdCardStartDate: { label: '证件有效开始日期', value: '请选择', placeholder: '' },
        grantIdCardEndDate: { label: '证件有效截止日期', value: '请选择', placeholder: '' },
        grantBankCardPicture: { label: '银行卡照片', value: '', placeholder: '' },
        grantBankCardNumber: { label: '银行卡号', value: '', type: '', placeholder: '请输入银行卡号' },
        grantBankName: { label: '所属银行', value: '请选择', placeholder: '' },
        grantBankArea: { label: '开户地区', value: '请选择', placeholder: '' },
        grantBankSubName: { label: '开户行', value: '请选择', sbno: '', placeholder: '' },
        grantAccountMobile: { label: '预留手机号', value: '', placeholder: '请输入预留手机号' },
        grantCertificatePicture: { label: '上传授权书', value: '', placeholder: '' },
        businessCycle: { label: '营业周期', value: '24小时', placeholder: '', mult: false },
      },
      commitmentData: {
        agreementFile1Picture: { label: '第1页', value: '', placeholder: '' },
        agreementFile2Picture: { label: '第2页', value: '', placeholder: '' },
        agreementFile3Picture: { label: '第3页', value: '', placeholder: '' },
        agreementFile4Picture: { label: '第4页', value: '', placeholder: '' },
        agreementFile5Picture: { label: '第5页', value: '', placeholder: '' },
        agreementFile6Picture: { label: '第6页', value: '', placeholder: '' },
        agreementType: { label: '协议类型', value: '电子协议', id: 0, placeholder: '', mult: true },
        commitmentNumber: { label: '授权书编号', value: '', placeholder: '' },
        commitmentPicture: { label: '上传承诺函', value: '', placeholder: '' },
      },
      popup: {
        title: '',
        parent: '',
        visible: false,
        type: 1,
        searchBar: {
          input: null,
          cancel: null,
        },
        searchSubBar: {
          input: null,
          cancel: null,
        },
        searchKey: '',
        searchSubKey: '',
        searchInputKey: '',
        searchSubInputKey: '',
        businessLicenseTypeArr: [
          { id: '1', label: '企业', value: 1, selected: true },
          { id: '3', label: '个体工商户', value: 3, selected: false },
        ],
        bankCardTypeArr: [
          { id: '1', label: '法人收款', value: 0, selected: true },
          { id: '2', label: '法人对私授权收款', value: 1, selected: false },
        ],
        agreementTypeArr: [
          { id: '1', label: '电子协议', value: 0, selected: true },
          { id: '2', label: '纸质协议', value: 1, selected: false },
        ],
        businessOpened: [],
        businessAllArr: [
          {
            itemName: '',
            businessId: '',
            businessName: '',
            businessLabel: '',
            subBusinessArr: [],
          },
        ],
        bankNameArr: [],
        bankAreaArr: [],
        bankAreaCityArr: [],
        bankSubNameArr: [],
        grantBankNameArr: [],
        grantBankAreaArr: [],
        grantBankAreaCityArr: [],
        grantBankSubNameArr: [],
      },
      areaPop: {
        visible: false,
        areaSlots: [
          { flex: 1, values: [], className: 'slot1', textAlign: 'center' },
          { flex: 1, values: [], className: 'slot2', textAlign: 'center' },
          { flex: 1, values: [], className: 'slot3', textAlign: 'center' },
        ],
      },
      picker: {
        parent: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: new Date(),
      },
      flow: {
        type: 'add',
        finished: false,
      },
      agreement: {
        id: '',
        type: 1,
        step: 0,
        mobile: '',
      },
      tmp: {
        minFee: 0,
        maxFee: 0,
        minCost: 0,
        maxCost: 0,
        bankAreaCity: '',
        grantBankAreaCity: '',
        parentBusinessId: '',
        parentBusinessName: '',
        getRateCodeErrMsg: '',
        commitmentNumber: '',
        selectedCompanyProvince: {
          id: '',
          value: '',
        },
        selectedCompanyCity: {
          id: '',
          value: '',
        },
        selectedCompanyArea: {
          id: '',
          value: '',
        },
        xwFaceUrl: '',
        xwCompanyMin: PUBLIC_XW_COMPANY_MIN,
        isAreaFinish: false,
        isNeedShort: false,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.currentTabIndex = 0;
      this.tabStatus.selected = [true, false, false, false, false];
      this.tabStatus.edited = [true, false, false, false, false];
      this.tabStatus.completed = [false, false, false, false, false];
      this.picker.startDate = new Date('1900-01-01');
      this.picker.endDate = new Date('2355-12-31');
      this.picker.selectedDate = new Date();
      this.flow.type = 'add';
      this.flow.finished = false;
      this.areaPop.areaSlots[0].values = this.POS_MANAGE_MODULE.globalCompanyProvince;
      this.areaPop.areaSlots[1].values = this.POS_MANAGE_MODULE.globalCompanyCity;
      this.areaPop.areaSlots[2].values = this.POS_MANAGE_MODULE.globalCompanyArea;
      this.currentIntoType = parseInt(this.$route.query.producttype);
      // 小微固定为法人
      if (this.currentIntoType === 1) {
        this.bankCardData.bankCardType.mult = false;
      }
      CusLoadingOpen();
      this.getCurrentAgentFee(() => {
        if (this.routeQueryId) {
          this.tabStatus.edited = [true, true, true, true, true];
          this.tabStatus.completed = [true, true, true, true, true];
          this.tmp.isNeedShort = true;
          this.fillPageAllData();
          CusLoadingClose();
        } else {
          this.fillPageAllDataByCache();
        }
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.flow.finished === false) {
      this.insertCustomerCache(() => {
        next();
      });
    } else {
      next();
    }
  },
  watch: {
    popupSearchKey(newVal) {
      if (!newVal) {
        let cityArr = null;
        switch (this.popup.parent) {
          case 'tradeType':
            if (localStorage.getItem('pos_global_business_list')) {
              // 2022.7.19 添加用pop()删除数组中最后这个时间戳的元素
              const tmpList = JSON.parse(localStorage.getItem('pos_global_business_list'));
              tmpList.pop();
              this.popup.businessAllArr = [];
              this.popup.businessAllArr = tmpList;
              this.popup.businessOpened = [];
              this.popup.businessAllArr.map(item => this.popup.businessOpened.push(item.itemName));
            }
            break;
          case 'bankName':
            this.popup.bankNameArr = [];
            this.getBankNameListByType('normal', this.bankCardData.bankName.value);
            break;
          case 'bankArea':
            this.popup.bankAreaArr = [];
            this.getBankProvinceName('normal', this.bankCardData.bankName.value, this.bankCardData.bankArea.value.split(' ')[0]);
            break;
          case 'bankSubName':
            this.popup.bankSubNameArr = [];
            cityArr = this.bankCardData.bankArea.value.split(' ');
            this.getBankName('normal', this.bankCardData.bankName.value, cityArr[0], cityArr[1], this.bankCardData.bankSubName.value);
            break;
          case 'grantBankName':
            this.popup.grantBankNameArr = [];
            this.getBankNameListByType('grant', this.bankCardData.grantBankName.value);
            break;
          case 'grantBankArea':
            this.popup.grantBankAreaArr = [];
            this.getBankProvinceName('grant', this.bankCardData.grantBankName.value, this.bankCardData.grantBankArea.value.split(' ')[0]);
            break;
          case 'grantBankSubName':
            this.popup.grantBankSubNameArr = [];
            cityArr = this.bankCardData.grantBankArea.value.split(' ');
            this.getBankName('grant', this.bankCardData.grantBankName.value, cityArr[0], cityArr[1], this.bankCardData.grantBankSubName.value);
            break;
        }
      }
    },
    popupSearchSubKey(newVal) {
      if (!newVal) {
        switch (this.popup.parent) {
          case 'bankAreaProvince':
            this.popup.bankAreaCityArr = [];
            this.getBankCityName('normal', this.bankCardData.bankName.value, this.tmp.bankAreaCity, this.bankCardData.bankArea.value.split(' ')[1]);
            break;
          case 'grantBankAreaProvince':
            this.popup.grantBankAreaCityArr = [];
            this.getBankCityName('grant', this.bankCardData.grantBankName.value, this.tmp.grantBankAreaCity, this.bankCardData.grantBankArea.value.split(' ')[1]);
            break;
        }
      }
    },
    selectedCompanyProvinceId(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.tmp.isAreaFinish = false;
        this.getProvinceCityAreaList(1, newVal);
      }
    },
    selectedCompanyCityId(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.tmp.isAreaFinish = false;
        this.getProvinceCityAreaList(2, newVal);
      }
    },
    selectedCompanyAreaId(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.tmp.isAreaFinish = true;
      }
    },
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    routeQueryId() {
      return this.$route.query.id;
    },
    popupSearchKey() {
      return this.popup.searchKey;
    },
    popupSearchSubKey() {
      return this.popup.searchSubKey;
    },
    agreementPageCount() {
      return PUBLIC_AGREEMENT_PAGE_COUNT;
    },
    selectedCompanyProvinceId() {
      return this.tmp.selectedCompanyProvince.id;
    },
    selectedCompanyCityId() {
      return this.tmp.selectedCompanyCity.id;
    },
    selectedCompanyAreaId() {
      return this.tmp.selectedCompanyArea.id;
    },
  },
  methods: {
    // 通过接口返回省/市/区
    getProvinceCityAreaList(index = 0, id = 0, callback = null) {
      GetAreaList({ parent_id: id, sortType: 1, masterType: 1 })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                this.areaPop.areaSlots[index].values = [];
                res.rows.forEach(item => {
                  this.areaPop.areaSlots[index].values.push({
                    label: item.area_name,
                    value: item.id,
                  });
                });
              }
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取代理商费率
    getCurrentAgentFee(callback = null) {
      GetCurrentAgentFee()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              const serviceFee = formatMoneyToYuan(res.data.serviceFee);
              const maxServiceFee = formatMoneyToYuan(res.data.maxServiceFee);
              this.rateData.normalRate.placeholder = `${res.data.fee}~${res.data.maxFee}`;
              this.rateData.normalCost.placeholder = `${serviceFee}~${maxServiceFee}`;
              this.tmp.minFee = res.data.fee;
              this.tmp.maxFee = res.data.maxFee;
              this.tmp.minCost = serviceFee;
              this.tmp.maxCost = maxServiceFee;
              // 2022.5.23 添加控制协议方
              if (this.currentIntoType === 1 && res.innerCode === 1) {
                this.commitmentData.agreementType.value = '自动签约';
                this.commitmentData.agreementType.mult = false;
                this.commitmentData.agreementType.id = 2;
              }
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.tmp.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取唯一的协议编号
    generateAuthNum(callback = null) {
      CusLoadingOpen();
      GenerateAuthNum()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.tmp.commitmentNumber = res.data;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
              this.tmp.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取身份证正反面信息
    getIdCardInformation(imgUrl, side, type) {
      CusLoadingOpen();
      GetIdCardInformation({ imgUrl, side })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res && res.data) {
                if (side === 1) {
                  if (type === 'corporation') {
                    this.corporationData.corporationName.value = res.data.name;
                    this.corporationData.corporationName.sex = res.data.sex;
                    this.corporationData.corporationName.birthday = res.data.birthday;
                    this.corporationData.corporationName.nationality = res.data.nationality;
                    this.corporationData.corporationName.address = res.data.address;
                    this.corporationData.identityCardNumber.value = res.data.idCardNum;
                  }
                  if (type === 'bankCard') {
                    this.bankCardData.grantCorporationName.value = res.data.name;
                    this.bankCardData.grantCorporationName.sex = res.data.sex;
                    this.bankCardData.grantCorporationName.birthday = res.data.birthday;
                    this.bankCardData.grantCorporationName.nationality = res.data.nationality;
                    this.bankCardData.grantCorporationName.address = res.data.address;
                    this.bankCardData.grantIdCardNumber.value = res.data.idCardNum;
                    this.bankCardData.grantIdCardAddress.value = res.data.address;
                  }
                } else {
                  if (type === 'corporation') {
                    this.corporationData.identityCardStartDate.value = res.data.dateOfIssue;
                    this.corporationData.identityCardEndDate.value = res.data.dateOfInvalid;
                    this.corporationData.corporationName.office = res.data.office;
                  }
                  if (type === 'bankCard') {
                    this.bankCardData.grantIdCardStartDate.value = res.data.dateOfIssue;
                    this.bankCardData.grantIdCardEndDate.value = res.data.dateOfInvalid;
                    this.bankCardData.grantCorporationName.office = res.data.office;
                  }
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡信息
    getBankCardInformation(imgUrl, type) {
      CusLoadingOpen();
      GetBankCardInformation({ imgUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res && res.data) {
                if (type === 'normal') {
                  this.bankCardData.bankCardNumber.value = res.data.ocrBankCardNum;
                  this.bankCardData.bankCardNumber.type = res.data.ocrBankCardType;
                  this.bankCardData.bankArea.value = '请选择';
                  this.bankCardData.bankSubName.value = '请选择';
                  this.bankCardData.bankSubName.sbno = '';
                }
                if (type === 'grant') {
                  this.bankCardData.grantBankCardNumber.value = res.data.ocrBankCardNum;
                  this.bankCardData.grantBankCardNumber.type = res.data.ocrBankCardType;
                  this.bankCardData.grantBankArea.value = '请选择';
                  this.bankCardData.grantBankSubName.value = '请选择';
                  this.bankCardData.grantBankSubName.sbno = '';
                }
                // 2022.5.30 日添加调用接口获取银行名称
                this.getSBNOByCardNum(this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''), type);
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡对应银行名
    getAllBankName(selectedValue) {
      CusLoadingOpen();
      GetAllBankName()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.bankNameArr.push({
                    label: item.bankName.replace('&', ''),
                    value: '',
                    selected: item.bankName === selectedValue,
                  });
                });
                // 2022.7.19 加入了判断缓存是否超过24小时，超过24小时则重新调用接口获取数据
                res.rows.push({ nowDate: Date.now() });
                localStorage.setItem('pos_global_bankname_list', JSON.stringify(res.rows));
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取被授权银行卡对应银行名
    getAllGrantlBankName(selectedValue) {
      CusLoadingOpen();
      GetAllBankName()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.grantBankNameArr.push({
                    label: item.bankName.replace('&', ''),
                    value: '',
                    selected: item.bankName === selectedValue,
                  });
                });
                // 2022.7.19 加入了判断缓存是否超过24小时，超过24小时则重新调用接口获取数据
                res.rows.push({ nowDate: Date.now() });
                localStorage.setItem('pos_global_grantbankname_list', JSON.stringify(res.rows));
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 获取银行卡对应银行名从接口或是缓存中
    getBankNameListByType(type, selectedValue = '') {
      // 2022.6.13 通过缓存获取银行卡对应银行名
      if (type === 'normal') {
        // 2022.6.13 加入了银行列表的前端缓存
        // 2022.7.18 加入判断缓存数据是否格式正确，如果存在但是length为0，则认为是格式错误的数据，重新调用接口获取数据
        // 2022.7.19 加入了判断缓存是否超过24小时，超过24小时则重新调用接口获取数据
        const bankNameStorageStr = localStorage.getItem('pos_global_bankname_list') || '';
        const bankNameStorageArr = bankNameStorageStr ? JSON.parse(bankNameStorageStr) : [];
        if (bankNameStorageStr && bankNameStorageArr.length > 0) {
          if (Date.now() - bankNameStorageArr[bankNameStorageArr.length - 1].nowDate > 24 * 60 * 60 * 1000) {
            this.getAllBankName(selectedValue);
          } else {
            const tmpList = JSON.parse(localStorage.getItem('pos_global_bankname_list'));
            tmpList.pop();
            tmpList.forEach(item => {
              this.popup.bankNameArr.push({
                label: item.bankName.replace('&', ''),
                value: '',
                selected: item.bankName === selectedValue,
              });
            });
          }
        } else {
          this.getAllBankName(selectedValue);
        }
      }
      if (type === 'grant') {
        // 2022.6.13 加入了银行列表的前端缓存
        // 2022.7.18 加入判断缓存数据是否格式正确，如果存在但是length为0，则认为是格式错误的数据，重新调用接口获取数据
        // 2022.7.19 加入了判断缓存是否超过24小时，超过24小时则重新调用接口获取数据
        const bankNameStorageStr = localStorage.getItem('pos_global_grantbankname_list') || '';
        const bankNameStorageArr = bankNameStorageStr ? JSON.parse(bankNameStorageStr) : [];
        if (bankNameStorageStr && bankNameStorageArr.length > 0) {
          if (Date.now() - bankNameStorageArr[bankNameStorageArr.length - 1].nowDate > 24 * 60 * 60 * 1000) {
            this.getAllGrantlBankName(selectedValue);
          } else {
            const tmpList = JSON.parse(localStorage.getItem('pos_global_grantbankname_list'));
            tmpList.pop();
            tmpList.forEach(item => {
              this.popup.grantBankNameArr.push({
                label: item.bankName.replace('&', ''),
                value: '',
                selected: item.bankName === selectedValue,
              });
            });
          }
        } else {
          this.getAllGrantlBankName(selectedValue);
        }
      }
    },
    // 通过接口获取银行卡地区信息
    getBankProvinceName(type, bankName, selectedValue = '') {
      CusLoadingOpen();
      GetBankProvinceName({ bankName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                if (type === 'normal') {
                  res.rows.forEach(item => {
                    this.popup.bankAreaArr.push({
                      label: item.provinceName,
                      value: item.provinceId,
                      selected: item.provinceName === selectedValue,
                    });
                  });
                }
                if (type === 'grant') {
                  res.rows.forEach(item => {
                    this.popup.grantBankAreaArr.push({
                      label: item.provinceName,
                      value: item.provinceId,
                      selected: item.provinceName === selectedValue,
                    });
                  });
                }
                if (this.popupSearchKey) {
                  this.onPopupSearchKeyup();
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡地区城市信息
    getBankCityName(type, bankName, provinceName, selectedValue = '') {
      CusLoadingOpen();
      GetBankCityName({ bankName, provinceName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                if (type === 'normal') {
                  res.rows.forEach(item => {
                    this.popup.bankAreaCityArr.push({
                      label: item.cityName,
                      selected: item.cityName === selectedValue,
                    });
                  });
                }
                if (type === 'grant') {
                  res.rows.forEach(item => {
                    this.popup.grantBankAreaCityArr.push({
                      label: item.cityName,
                      selected: item.cityName === selectedValue,
                    });
                  });
                }
                if (this.popupSearchSubKey) {
                  this.onPopupSearchSubKeyup();
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡开户行信息
    getBankName(type, bankName, provinceName, cityName, selectedValue = '') {
      CusLoadingOpen();
      GetBankName({ bankName, provinceName, cityName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                if (type === 'normal') {
                  res.rows.forEach(item => {
                    this.popup.bankSubNameArr.push({
                      label: item.bankAllName,
                      value: item.sbno,
                      selected: item.bankAllName === selectedValue,
                    });
                  });
                }
                if (type === 'grant') {
                  res.rows.forEach(item => {
                    this.popup.grantBankSubNameArr.push({
                      label: item.bankAllName,
                      value: item.sbno,
                      selected: item.bankAllName === selectedValue,
                    });
                  });
                }
                if (this.popupSearchKey) {
                  this.onPopupSearchKeyup();
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口根据银行卡号返回清算行信息
    getSBNOByCardNum(number, type) {
      GetSBNOByCardNum({ bankCardNum: number, repeatCheck: 1 })
        .then(res => {
          SucceedHandle2(res.code, res.msg, () => {
            if (type === 'normal') {
              this.bankCardData.bankCardNumber.type = res.data.cardType;
              this.bankCardData.bankName.value = res.data.bankName;
            }
            if (type === 'grant') {
              this.bankCardData.grantBankCardNumber.type = res.data.cardType;
              this.bankCardData.grantBankName.value = res.data.bankName;
            }
          });
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口根据银行卡号返回清算行信息2
    getSBNOByCardNumForBtn(number, callBack = null) {
      GetSBNOByCardNum({ bankCardNum: number, repeatCheck: 1 })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callBack && callBack();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取营业执照信息
    getBusinessLicenseInfo(imgUrl) {
      CusLoadingOpen();
      GetBusinessLicenseInfo({ imgUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.companyData.licenseNumber.value = res.data.ocrBusinessLicenseNum;
              this.companyData.licenseNumber.person = res.data.ocrJuridicalPerson || '';
              this.companyData.companyName.value = res.data.ocrCompanyName ? res.data.ocrCompanyName.replace(/\s/gi, '') : '';
              this.companyData.licenseScope.value = res.data.ocrBusinessScope;
              this.companyData.companyAddress.value = res.data.ocrCompanyAddress;
              this.companyData.licenceStartDate.value = formatLicenseDate(res.data.ocrEstablishmentDate);
              const tmpValidDate = formatLicenseDate(res.data.ocrLicenceValidDate);
              this.companyData.licenseValidDate.value = tmpValidDate === '无' || tmpValidDate === '永久' ? '长期' : tmpValidDate;
              const strType = String(res.data.ocrLicenseType);
              if (strType.indexOf('企业') > -1 || strType.indexOf('公司') > -1) {
                this.companyData.businessLicenseType.value = '企业';
                this.companyData.businessLicenseType.id = 1;
                this.popup.businessLicenseTypeArr.forEach(item => (item.selected = false));
                this.popup.businessLicenseTypeArr[0].selected = true;
              }
              if (strType.indexOf('个体') > -1) {
                this.companyData.businessLicenseType.value = '个体工商户';
                this.companyData.businessLicenseType.id = 3;
                this.popup.businessLicenseTypeArr.forEach(item => (item.selected = false));
                this.popup.businessLicenseTypeArr[1].selected = true;
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取当前代理商是否在黑名单中
    queryBlackList(type, value, callback = null) {
      QueryBlacklist({ type, value })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口判断营业执照开始时间能否进件，格式yyyyMMdd
    businessStartDateParse(licenceStartDate, callback = null) {
      BusinessStartDateParse({ value: licenceStartDate })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口查询当前身份证号注册数量是否超限
    isReachedMaximumLimitByIdCardNum(cardNum, callback = null) {
      IsReachedMaximumLimitByIdCardNum({ idCardNum: cardNum, subjectType: this.currentIntoType })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口校验当前公司名称是否合法
    isLegitimacyForCompanyName(companyName, companyShortName, callback = null) {
      IsLegitimacyForCompanyName({ name: companyName, shortName: companyShortName, subjectType: this.currentIntoType })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              if (res.innerCode === 1) {
                CusAlert(msg, () => (this.tmp.isNeedShort = true));
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口校验当前公司所在区域是否合法
    isLegitimacyForCompanyArea(provinceId, cityId, countyId, callback = null) {
      IsLegitimacyForCompanyArea({ provinceId, cityId, countyId })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口校验公司地址是否合法
    isLegitimacyForCompanyAddress(companyAddress, callback = null) {
      IsLegitimacyForCompanyAddress({ companyAddress })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口对新建的代理商商户进件审核
    insertNewCustomerData() {
      CusLoadingOpen();
      const data = {
        address: this.corporationData.corporationName.address,
        agreementPicUrl: [],
        agreementType: this.commitmentData.agreementType.id,
        authorizationPicUrl: '',
        bankCardFrontPicUrl: this.bankCardData.bankCardPicture.value,
        bankCardNum: this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''),
        bankFullName: this.bankCardData.bankSubName.value,
        sbNo: this.bankCardData.bankSubName.sbno,
        bankName: this.bankCardData.bankName.value,
        bankPhoneNum: this.bankCardData.accountMobile.value.replace(/\s/gi, ''),
        bankProvinceName: this.bankCardData.bankArea.value.split(' ')[0],
        bankCityName: this.bankCardData.bankArea.value.split(' ')[1],
        birthday: this.corporationData.corporationName.birthday,
        businessLicense: this.companyData.licenseNumber.value,
        businessScope: this.companyData.licenseScope.value,
        certificateType: 0,
        cityId: this.companyData.companyCity.id,
        collectType: this.bankCardData.bankCardType.id,
        companyAddress: this.companyData.companyAddress.value,
        companyBusinessName: this.companyData.companyLicenseName.value,
        companyEnglishName: this.companyData.companyEnglishName.value,
        companyName: this.companyData.companyName.value.replace(/\s/gi, ''),
        companyShortName: this.companyData.companyShortName.value.replace(/\s/gi, ''), // 2022.8.18 简称
        companyPhone: '',
        contacterIdcardNum: this.corporationData.liaisonIdentityCardNo.value.replace(/\s/gi, ''),
        contacterMobile: this.corporationData.liaisonMobile.value.replace(/\s/gi, ''),
        contacterName: this.corporationData.liaisonName.value,
        countyId: this.companyData.companyArea.id,
        dateOfInvalid: this.corporationData.identityCardEndDate.value,
        dateOfIssue: this.corporationData.identityCardStartDate.value,
        fee: formatRateForSubmit(this.rateData.normalRate.value),
        holderName: this.bankCardData.accountName.value,
        idCardBackUrl: this.corporationData.identityCardPictureBack.value,
        idCardFrontUrl: this.corporationData.identityCardPictureFront.value,
        idCardName: this.corporationData.corporationName.value,
        idCardNum: this.corporationData.identityCardNumber.value.replace(/\s/gi, ''),
        idCardType: 0,
        industryId: this.companyData.tradeType.id,
        licenceStartDate: this.companyData.licenceStartDate.value,
        licenceValidDate: this.companyData.licenseValidDate.value,
        licensePhoto: this.companyData.licensePicture.value,
        mobile: this.corporationData.corporationMobile.value.replace(/\s/gi, ''),
        nationality: this.corporationData.corporationName.nationality,
        office: this.corporationData.corporationName.office,
        operatingCycle: this.bankCardData.businessCycle.value,
        provinceId: this.companyData.companyProvince.id,
        serviceFee: 0,
        sex: this.corporationData.corporationName.sex,
        storeCashierImgUrl: this.companyData.cashierPicture.value,
        storeHeaderImgUrl: this.companyData.shopPicture.value,
        storeIndoorImgUrl: this.companyData.placePicture.value,
        subjectType: 0, // 营业执照
        accountType: this.companyData.businessLicenseType.id,
        authNumber: this.commitmentData.commitmentNumber.value,
        authCommitmentPicUrl: this.commitmentData.commitmentPicture.value,
        otherImg1: this.companyData.other1Picture.value,
        otherImg2: this.companyData.other2Picture.value,
      };
      if (this.bankCardData.bankCardType.id === 1) {
        data.authBankCardFrontPicUrl = this.bankCardData.grantBankCardPicture.value;
        data.authIdCardFrontUrl = this.bankCardData.grantIdCardPictureFront.value;
        data.authIdCardBackUrl = this.bankCardData.grantIdCardPictureBack.value;
        data.authorizationPicUrl = this.bankCardData.grantCertificatePicture.value;
        data.authIdCardName = this.bankCardData.grantCorporationName.value;
        data.authIdCardNum = this.bankCardData.grantIdCardNumber.value.replace(/\s/gi, '');
        data.authIdCardAddress = this.bankCardData.grantIdCardAddress.value;
        data.authDateOfIssue = this.bankCardData.grantIdCardStartDate.value;
        data.authDateOfInvalid = this.bankCardData.grantIdCardEndDate.value;
        data.authBankCardNum = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        data.authBankName = this.bankCardData.grantBankName.value;
        data.authSbNo = this.bankCardData.grantBankSubName.sbno;
        data.authBankFullName = this.bankCardData.grantBankSubName.value;
        data.authBankProvinceName = this.bankCardData.grantBankArea.value.split(' ')[0];
        data.authBankCityName = this.bankCardData.grantBankArea.value.split(' ')[1];
        data.authBankPhoneNum = this.bankCardData.grantAccountMobile.value.replace(/\s/gi, '');
      }
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile1Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile2Picture.value);
        }
        if (this.agreementPageCount >= 4) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile3Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile4Picture.value);
        }
        if (this.agreementPageCount >= 6) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile5Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile6Picture.value);
        }
      }
      InsertNewCustomerData(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.flow.type = 'add';
              this.flow.finished = true;
              this.agreement.type = this.commitmentData.agreementType.id;
              this.agreement.id = res.data.id;
              this.agreement.step = res.data.agreementSteps;
              this.agreement.mobile = res.data.mobile;
              this.$forceUpdate();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口对新建的小微商户进件审核
    insertNewXiaoWeiCustomerData() {
      CusLoadingOpen();
      const data = {
        address: this.corporationData.corporationName.address,
        agreementPicUrl: [],
        agreementType: this.commitmentData.agreementType.id,
        authorizationPicUrl: '',
        bankCardFrontPicUrl: this.bankCardData.bankCardPicture.value,
        bankCardNum: this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''),
        bankFullName: this.bankCardData.bankSubName.value,
        sbNo: this.bankCardData.bankSubName.sbno,
        bankName: this.bankCardData.bankName.value,
        bankPhoneNum: this.bankCardData.accountMobile.value.replace(/\s/gi, ''),
        bankProvinceName: this.bankCardData.bankArea.value.split(' ')[0],
        bankCityName: this.bankCardData.bankArea.value.split(' ')[1],
        birthday: this.corporationData.corporationName.birthday,
        businessLicense: '', // this.companyData.licenseNumber.value,//删掉
        businessScope: this.companyData.licenseScope.value,
        certificateType: 4,
        cityId: this.companyData.companyCity.id,
        collectType: this.bankCardData.bankCardType.id,
        companyAddress: this.companyData.companyAddress.value,
        companyBusinessName: this.companyData.companyLicenseName.value,
        companyEnglishName: this.companyData.companyEnglishName.value,
        companyName: this.companyData.companyName.value.replace(/\s/gi, ''),
        companyPhone: '',
        contacterIdcardNum: this.corporationData.liaisonIdentityCardNo.value.replace(/\s/gi, ''),
        contacterMobile: this.corporationData.liaisonMobile.value.replace(/\s/gi, ''),
        contacterName: this.corporationData.liaisonName.value,
        countyId: this.companyData.companyArea.id,
        dateOfInvalid: this.corporationData.identityCardEndDate.value,
        dateOfIssue: this.corporationData.identityCardStartDate.value,
        fee: formatRateForSubmit(this.rateData.normalRate.value),
        holderName: this.bankCardData.accountName.value,
        idCardBackUrl: this.corporationData.identityCardPictureBack.value,
        idCardFrontUrl: this.corporationData.identityCardPictureFront.value,
        idCardName: this.corporationData.corporationName.value,
        idCardNum: this.corporationData.identityCardNumber.value.replace(/\s/gi, ''),
        idCardType: 0,
        industryId: this.companyData.tradeType.id,
        licenceStartDate: '',
        licenceValidDate: '',
        licensePhoto: '',
        mobile: this.corporationData.corporationMobile.value.replace(/\s/gi, ''),
        nationality: this.corporationData.corporationName.nationality,
        office: this.corporationData.corporationName.office,
        operatingCycle: this.bankCardData.businessCycle.value,
        provinceId: this.companyData.companyProvince.id,
        serviceFee: 0,
        sex: this.corporationData.corporationName.sex,
        storeCashierImgUrl: this.companyData.cashierPicture.value,
        storeHeaderImgUrl: this.companyData.shopPicture.value,
        storeIndoorImgUrl: this.companyData.placePicture.value,
        subjectType: 1,
        accountType: 2,
        authNumber: this.commitmentData.commitmentNumber.value,
        authCommitmentPicUrl: this.commitmentData.commitmentPicture.value,
        otherImg1: this.companyData.other1Picture.value,
        otherImg2: this.companyData.other2Picture.value,
      };
      if (this.bankCardData.bankCardType.id === 1) {
        data.authBankCardFrontPicUrl = this.bankCardData.grantBankCardPicture.value;
        data.authIdCardFrontUrl = this.bankCardData.grantIdCardPictureFront.value;
        data.authIdCardBackUrl = this.bankCardData.grantIdCardPictureBack.value;
        data.authorizationPicUrl = this.bankCardData.grantCertificatePicture.value;
        data.authIdCardName = this.bankCardData.grantCorporationName.value;
        data.authIdCardNum = this.bankCardData.grantIdCardNumber.value.replace(/\s/gi, '');
        data.authIdCardAddress = this.bankCardData.grantIdCardAddress.value;
        data.authDateOfIssue = this.bankCardData.grantIdCardStartDate.value;
        data.authDateOfInvalid = this.bankCardData.grantIdCardEndDate.value;
        data.authBankCardNum = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        data.authBankName = this.bankCardData.grantBankName.value;
        data.authSbNo = this.bankCardData.grantBankSubName.sbno;
        data.authBankFullName = this.bankCardData.grantBankSubName.value;
        data.authBankProvinceName = this.bankCardData.grantBankArea.value.split(' ')[0];
        data.authBankCityName = this.bankCardData.grantBankArea.value.split(' ')[1];
        data.authBankPhoneNum = this.bankCardData.grantAccountMobile.value.replace(/\s/gi, '');
      }
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile1Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile2Picture.value);
        }
        if (this.agreementPageCount >= 4) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile3Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile4Picture.value);
        }
        if (this.agreementPageCount >= 6) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile5Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile6Picture.value);
        }
      }
      InsertNewCustomerData(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.flow.type = 'add';
              this.flow.finished = true;
              this.agreement.type = this.commitmentData.agreementType.id;
              this.agreement.id = res.data.id;
              this.agreement.step = res.data.agreementSteps;
              this.agreement.mobile = res.data.mobile;
              this.tmp.xwFaceUrl = `${location.href.split('?')[0]}?product=cxzfzs#/posmanagemodule/livingbody?id=${res.data.id}`;
              this.$forceUpdate();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口对新建的代理商商户的数据进行缓存
    insertCustomerCache(callback = null) {
      if (this.routeQueryId) {
        callback && callback();
        return;
      }
      let strTabSelected = '';
      this.tabStatus.selected.forEach(item => {
        strTabSelected += item ? '1' : '0';
      });
      let strTabEdited = '';
      this.tabStatus.edited.forEach(item => {
        strTabEdited += item ? '1' : '0';
      });
      let strTabCompleted = '';
      this.tabStatus.completed.forEach(item => {
        strTabCompleted += item ? '1' : '0';
      });
      const data = {
        pageNum: 0,
        currentTabIndex: this.currentTabIndex,
        tabStatusSelected: strTabSelected,
        tabStatusEdited: strTabEdited,
        tabStatusCompleted: strTabCompleted,
        address: this.corporationData.corporationName.address,
        agreementPicUrl: [],
        agreementType: this.commitmentData.agreementType.id,
        authorizationPicUrl: '',
        bankCardFrontPicUrl: this.bankCardData.bankCardPicture.value,
        bankCardNum: this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''),
        bankFullName: this.bankCardData.bankSubName.value,
        sbNo: this.bankCardData.bankSubName.sbno,
        bankName: this.bankCardData.bankName.value,
        bankPhoneNum: this.bankCardData.accountMobile.value.replace(/\s/gi, ''),
        bankProvinceName: this.bankCardData.bankArea.value !== '请选择' ? this.bankCardData.bankArea.value.split(' ')[0] : '请选择',
        bankCityName: this.bankCardData.bankArea.value !== '请选择' ? this.bankCardData.bankArea.value.split(' ')[1] : '',
        birthday: this.corporationData.corporationName.birthday,
        businessLicense: this.companyData.licenseNumber.value,
        businessScope: this.companyData.licenseScope.value,
        certificateType: 0,
        cityText: this.companyData.companyCity.value,
        cityId: this.companyData.companyCity.id,
        collectType: this.bankCardData.bankCardType.id,
        companyAddress: this.companyData.companyAddress.value,
        companyBusinessName: this.companyData.companyLicenseName.value,
        companyEnglishName: this.companyData.companyEnglishName.value,
        companyName: this.companyData.companyName.value,
        companyShortName: this.companyData.companyShortName.value, // 2022.8.18 简称
        companyPhone: '',
        contacterIdcardNum: this.corporationData.liaisonIdentityCardNo.value.replace(/\s/gi, ''),
        contacterMobile: this.corporationData.liaisonMobile.value.replace(/\s/gi, ''),
        contacterName: this.corporationData.liaisonName.value,
        countyText: this.companyData.companyArea.value,
        countyId: this.companyData.companyArea.id,
        dateOfInvalid: this.corporationData.identityCardEndDate.value,
        dateOfIssue: this.corporationData.identityCardStartDate.value,
        fee: formatRateForSubmit(this.rateData.normalRate.value),
        holderName: this.bankCardData.accountName.value || this.corporationData.corporationName.value,
        idCardBackUrl: this.corporationData.identityCardPictureBack.value,
        idCardFrontUrl: this.corporationData.identityCardPictureFront.value,
        idCardName: this.corporationData.corporationName.value,
        idCardNum: this.corporationData.identityCardNumber.value.replace(/\s/gi, ''),
        idCardType: 0,
        industryText: this.companyData.tradeType.value,
        industryId: this.companyData.tradeType.id,
        licenceStartDate: this.companyData.licenceStartDate.value,
        licenceValidDate: this.companyData.licenseValidDate.value,
        licensePhoto: this.companyData.licensePicture.value,
        mobile: this.corporationData.corporationMobile.value.replace(/\s/gi, ''),
        nationality: this.corporationData.corporationName.nationality,
        office: this.corporationData.corporationName.office,
        operatingCycle: this.bankCardData.businessCycle.value,
        provinceText: this.companyData.companyProvince.value,
        provinceId: this.companyData.companyProvince.id,
        serviceFee: 0,
        sex: this.corporationData.corporationName.sex,
        storeCashierImgUrl: this.companyData.cashierPicture.value,
        storeHeaderImgUrl: this.companyData.shopPicture.value,
        storeIndoorImgUrl: this.companyData.placePicture.value,
        subjectType: this.currentIntoType,
        accountType: this.companyData.businessLicenseType.id,
        authNumber: this.commitmentData.commitmentNumber.value,
        authCommitmentPicUrl: this.commitmentData.commitmentPicture.value,
        otherImg1: this.companyData.other1Picture.value,
        otherImg2: this.companyData.other2Picture.value,
      };
      if (this.bankCardData.bankCardType.id === 1) {
        data.authBankCardFrontPicUrl = this.bankCardData.grantBankCardPicture.value;
        data.authIdCardFrontUrl = this.bankCardData.grantIdCardPictureFront.value;
        data.authIdCardBackUrl = this.bankCardData.grantIdCardPictureBack.value;
        data.authorizationPicUrl = this.bankCardData.grantCertificatePicture.value;
        data.authIdCardName = this.bankCardData.grantCorporationName.value;
        data.authIdCardNum = this.bankCardData.grantIdCardNumber.value.replace(/\s/gi, '');
        data.authIdCardAddress = this.bankCardData.grantIdCardAddress.value;
        data.authDateOfIssue = this.bankCardData.grantIdCardStartDate.value;
        data.authDateOfInvalid = this.bankCardData.grantIdCardEndDate.value;
        data.authBankCardNum = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        data.authBankName = this.bankCardData.grantBankName.value;
        data.authSbNo = this.bankCardData.grantBankSubName.sbno;
        data.authBankFullName = this.bankCardData.grantBankSubName.value;
        data.authBankProvinceName = this.bankCardData.grantBankArea.value !== '请选择' ? this.bankCardData.grantBankArea.value.split(' ')[0] : '请选择';
        data.authBankCityName = this.bankCardData.grantBankArea.value !== '请选择' ? this.bankCardData.grantBankArea.value.split(' ')[1] : '';
        data.authBankPhoneNum = this.bankCardData.grantAccountMobile.value.replace(/\s/gi, '');
      }
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile1Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile2Picture.value);
        }
        if (this.agreementPageCount >= 4) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile3Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile4Picture.value);
        }
        if (this.agreementPageCount >= 6) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile5Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile6Picture.value);
        }
      }
      InsertCustomerCache(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            () => {
              CusAlert('程序出错，无法保存当前填写的数据', () => {
                callback && callback();
              });
            }
          );
        })
        .catch(() => {
          CusAlert('网络出错，无法保存当前填写的数据', () => {
            callback && callback();
          });
        });
    },
    // 通过接口对重新编辑的代理商商户进件审核
    editCustomerData() {
      CusLoadingOpen();
      const data = {
        _id: this.routeQueryId,
        address: this.corporationData.corporationName.address,
        agreementPicUrl: [],
        agreementType: this.commitmentData.agreementType.id,
        authorizationPicUrl: '',
        bankCardFrontPicUrl: this.bankCardData.bankCardPicture.value,
        bankCardNum: this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''),
        bankFullName: this.bankCardData.bankSubName.value,
        sbNo: this.bankCardData.bankSubName.sbno,
        bankName: this.bankCardData.bankName.value,
        bankPhoneNum: this.bankCardData.accountMobile.value.replace(/\s/gi, ''),
        bankProvinceName: this.bankCardData.bankArea.value.split(' ')[0],
        bankCityName: this.bankCardData.bankArea.value.split(' ')[1],
        birthday: this.corporationData.corporationName.birthday,
        businessLicense: this.companyData.licenseNumber.value,
        businessScope: this.companyData.licenseScope.value,
        certificateType: 0,
        cityId: this.companyData.companyCity.id,
        collectType: this.bankCardData.bankCardType.id,
        companyAddress: this.companyData.companyAddress.value,
        companyBusinessName: this.companyData.companyLicenseName.value,
        companyEnglishName: this.companyData.companyEnglishName.value,
        companyName: this.companyData.companyName.value.replace(/\s/gi, ''),
        companyShortName: this.companyData.companyShortName.value.replace(/\s/gi, ''), // 2022.8.18 简称
        companyPhone: '',
        contacterIdcardNum: this.corporationData.liaisonIdentityCardNo.value.replace(/\s/gi, ''),
        contacterMobile: this.corporationData.liaisonMobile.value.replace(/\s/gi, ''),
        contacterName: this.corporationData.liaisonName.value,
        countyId: this.companyData.companyArea.id,
        dateOfInvalid: this.corporationData.identityCardEndDate.value,
        dateOfIssue: this.corporationData.identityCardStartDate.value,
        fee: formatRateForSubmit(this.rateData.normalRate.value),
        holderName: this.bankCardData.accountName.value,
        idCardBackUrl: this.corporationData.identityCardPictureBack.value,
        idCardFrontUrl: this.corporationData.identityCardPictureFront.value,
        idCardName: this.corporationData.corporationName.value,
        idCardNum: this.corporationData.identityCardNumber.value.replace(/\s/gi, ''),
        idCardType: 0,
        industryId: this.companyData.tradeType.id,
        licenceStartDate: this.companyData.licenceStartDate.value,
        licenceValidDate: this.companyData.licenseValidDate.value,
        licensePhoto: this.companyData.licensePicture.value,
        mobile: this.corporationData.corporationMobile.value.replace(/\s/gi, ''),
        nationality: this.corporationData.corporationName.nationality,
        office: this.corporationData.corporationName.office,
        operatingCycle: this.bankCardData.businessCycle.value,
        provinceId: this.companyData.companyProvince.id,
        serviceFee: 0,
        sex: this.corporationData.corporationName.sex,
        storeCashierImgUrl: this.companyData.cashierPicture.value,
        storeHeaderImgUrl: this.companyData.shopPicture.value,
        storeIndoorImgUrl: this.companyData.placePicture.value,
        subjectType: 0,
        accountType: this.companyData.businessLicenseType.id,
        authNumber: this.commitmentData.commitmentNumber.value,
        authCommitmentPicUrl: this.commitmentData.commitmentPicture.value,
        otherImg1: this.companyData.other1Picture.value,
        otherImg2: this.companyData.other2Picture.value,
      };
      if (this.bankCardData.bankCardType.id === 1) {
        data.authBankCardFrontPicUrl = this.bankCardData.grantBankCardPicture.value;
        data.authIdCardFrontUrl = this.bankCardData.grantIdCardPictureFront.value;
        data.authIdCardBackUrl = this.bankCardData.grantIdCardPictureBack.value;
        data.authorizationPicUrl = this.bankCardData.grantCertificatePicture.value;
        data.authIdCardName = this.bankCardData.grantCorporationName.value;
        data.authIdCardNum = this.bankCardData.grantIdCardNumber.value.replace(/\s/gi, '');
        data.authIdCardAddress = this.bankCardData.grantIdCardAddress.value;
        data.authDateOfIssue = this.bankCardData.grantIdCardStartDate.value;
        data.authDateOfInvalid = this.bankCardData.grantIdCardEndDate.value;
        data.authBankCardNum = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        data.authBankName = this.bankCardData.grantBankName.value;
        data.authSbNo = this.bankCardData.grantBankSubName.sbno;
        data.authBankFullName = this.bankCardData.grantBankSubName.value;
        data.authBankProvinceName = this.bankCardData.grantBankArea.value.split(' ')[0];
        data.authBankCityName = this.bankCardData.grantBankArea.value.split(' ')[1];
        data.authBankPhoneNum = this.bankCardData.grantAccountMobile.value.replace(/\s/gi, '');
      }
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile1Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile2Picture.value);
        }
        if (this.agreementPageCount >= 4) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile3Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile4Picture.value);
        }
        if (this.agreementPageCount >= 6) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile5Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile6Picture.value);
        }
      }
      EditCustomerData(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.flow.type = 'edit';
              this.flow.finished = true;
              this.agreement.type = this.commitmentData.agreementType.id;
              this.$forceUpdate();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口对重新编辑的小微商户进件审核
    editXiaoWeiCustomerData() {
      CusLoadingOpen();
      const data = {
        _id: this.routeQueryId,
        address: this.corporationData.corporationName.address,
        agreementPicUrl: [],
        agreementType: this.commitmentData.agreementType.id,
        authorizationPicUrl: '',
        bankCardFrontPicUrl: this.bankCardData.bankCardPicture.value,
        bankCardNum: this.bankCardData.bankCardNumber.value.replace(/\s/gi, ''),
        bankFullName: this.bankCardData.bankSubName.value,
        sbNo: this.bankCardData.bankSubName.sbno,
        bankName: this.bankCardData.bankName.value,
        bankPhoneNum: this.bankCardData.accountMobile.value.replace(/\s/gi, ''),
        bankProvinceName: this.bankCardData.bankArea.value.split(' ')[0],
        bankCityName: this.bankCardData.bankArea.value.split(' ')[1],
        birthday: this.corporationData.corporationName.birthday,
        businessLicense: '',
        businessScope: this.companyData.licenseScope.value,
        certificateType: 4,
        cityId: this.companyData.companyCity.id,
        collectType: this.bankCardData.bankCardType.id,
        companyAddress: this.companyData.companyAddress.value,
        companyBusinessName: this.companyData.companyLicenseName.value,
        companyEnglishName: this.companyData.companyEnglishName.value,
        companyName: this.companyData.companyName.value.replace(/\s/gi, ''),
        companyPhone: '',
        contacterIdcardNum: this.corporationData.liaisonIdentityCardNo.value.replace(/\s/gi, ''),
        contacterMobile: this.corporationData.liaisonMobile.value.replace(/\s/gi, ''),
        contacterName: this.corporationData.liaisonName.value,
        countyId: this.companyData.companyArea.id,
        dateOfInvalid: this.corporationData.identityCardEndDate.value,
        dateOfIssue: this.corporationData.identityCardStartDate.value,
        fee: formatRateForSubmit(this.rateData.normalRate.value),
        holderName: this.bankCardData.accountName.value,
        idCardBackUrl: this.corporationData.identityCardPictureBack.value,
        idCardFrontUrl: this.corporationData.identityCardPictureFront.value,
        idCardName: this.corporationData.corporationName.value,
        idCardNum: this.corporationData.identityCardNumber.value.replace(/\s/gi, ''),
        idCardType: 0,
        industryId: this.companyData.tradeType.id,
        licenceStartDate: '',
        licenceValidDate: '',
        licensePhoto: '',
        mobile: this.corporationData.corporationMobile.value.replace(/\s/gi, ''),
        nationality: this.corporationData.corporationName.nationality,
        office: this.corporationData.corporationName.office,
        operatingCycle: this.bankCardData.businessCycle.value,
        provinceId: this.companyData.companyProvince.id,
        serviceFee: 0,
        sex: this.corporationData.corporationName.sex,
        storeCashierImgUrl: this.companyData.cashierPicture.value,
        storeHeaderImgUrl: this.companyData.shopPicture.value,
        storeIndoorImgUrl: this.companyData.placePicture.value,
        subjectType: 1,
        accountType: 2,
        authNumber: this.commitmentData.commitmentNumber.value,
        authCommitmentPicUrl: this.commitmentData.commitmentPicture.value,
        otherImg1: this.companyData.other1Picture.value,
        otherImg2: this.companyData.other2Picture.value,
      };
      if (this.bankCardData.bankCardType.id === 1) {
        data.authBankCardFrontPicUrl = this.bankCardData.grantBankCardPicture.value;
        data.authIdCardFrontUrl = this.bankCardData.grantIdCardPictureFront.value;
        data.authIdCardBackUrl = this.bankCardData.grantIdCardPictureBack.value;
        data.authorizationPicUrl = this.bankCardData.grantCertificatePicture.value;
        data.authIdCardName = this.bankCardData.grantCorporationName.value;
        data.authIdCardNum = this.bankCardData.grantIdCardNumber.value.replace(/\s/gi, '');
        data.authIdCardAddress = this.bankCardData.grantIdCardAddress.value;
        data.authDateOfIssue = this.bankCardData.grantIdCardStartDate.value;
        data.authDateOfInvalid = this.bankCardData.grantIdCardEndDate.value;
        data.authBankCardNum = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        data.authBankName = this.bankCardData.grantBankName.value;
        data.authSbNo = this.bankCardData.grantBankSubName.sbno;
        data.authBankFullName = this.bankCardData.grantBankSubName.value;
        data.authBankProvinceName = this.bankCardData.grantBankArea.value.split(' ')[0];
        data.authBankCityName = this.bankCardData.grantBankArea.value.split(' ')[1];
        data.authBankPhoneNum = this.bankCardData.grantAccountMobile.value.replace(/\s/gi, '');
      }
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile1Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile2Picture.value);
        }
        if (this.agreementPageCount >= 4) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile3Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile4Picture.value);
        }
        if (this.agreementPageCount >= 6) {
          data.agreementPicUrl.push(this.commitmentData.agreementFile5Picture.value);
          data.agreementPicUrl.push(this.commitmentData.agreementFile6Picture.value);
        }
      }
      EditCustomerData(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.flow.type = 'edit';
              this.flow.finished = true;
              this.agreement.type = this.commitmentData.agreementType.id;
              this.tmp.xwFaceUrl = `${location.href.split('?')[0]}?product=cxzfzs#/posmanagemodule/livingbody?id=${res.data.id}`;
              this.$forceUpdate();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 用detail中存的数据填充页面
    fillPageAllData() {
      const data = this.POS_MANAGE_MODULE.globalData;
      // 费率
      this.rateData.normalRate.value = formatRateForShow(data.rate.fee);
      // 企业
      this.companyData.businessLicenseType.id = data.company.accountType;
      this.popup.businessLicenseTypeArr.forEach(item => (item.selected = false));
      this.companyData.businessLicenseType.value = data.company.accountType === 1 ? '企业' : '个体工商户';
      if (data.company.accountType === 1) {
        this.popup.businessLicenseTypeArr[0].selected = true;
      } else if (data.company.accountType === 3) {
        this.popup.businessLicenseTypeArr[1].selected = true;
      }
      this.companyData.other1Picture.value = data.company.otherImg1;
      this.companyData.other2Picture.value = data.company.otherImg2;
      this.companyData.licensePicture.value = data.company.licensePhoto;
      this.companyData.shopPicture.value = data.company.storeHeaderImgUrl;
      this.companyData.placePicture.value = data.company.storeIndoorImgUrl;
      this.companyData.cashierPicture.value = data.company.storeCashierImgUrl;
      this.companyData.tradeType.value = data.company.industryName;
      this.companyData.tradeType.id = data.company.industryId;
      this.companyData.licenseScope.value = data.company.businessScope;
      this.companyData.licenseNumber.value = data.company.businessLicense;
      this.companyData.companyName.value = data.company.companyName;
      this.companyData.companyShortName.value = data.company.companyShortName; // 2022.8.18 简称
      this.companyData.companyLicenseName.value = data.company.companyBusinessName;
      this.companyData.companyEnglishName.value = data.company.companyEnglishName;
      this.companyData.companyProvince.value = data.company.provinceName;
      this.companyData.companyProvince.id = data.company.provinceId;
      this.companyData.companyCity.value = data.company.cityName;
      this.companyData.companyCity.id = data.company.cityId;
      this.companyData.companyArea.value = data.company.countyName;
      this.companyData.companyArea.id = data.company.countyId;
      this.companyData.companyAddress.value = data.company.companyAddress;
      this.companyData.licenceStartDate.value = data.company.licenceStartDate;
      this.companyData.licenseValidDate.value = data.company.licenceValidDate;
      // 法人
      this.corporationData.identityCardPictureFront.value = data.idCardInfo.idCardFrontUrl;
      this.corporationData.identityCardPictureBack.value = data.idCardInfo.idCardBackUrl;
      this.corporationData.corporationName.value = data.idCardInfo.idCardName;
      this.corporationData.identityCardNumber.value = data.idCardInfo.idCardNum;
      this.corporationData.identityCardStartDate.value = data.idCardInfo.dateOfIssue;
      this.corporationData.identityCardEndDate.value = data.idCardInfo.dateOfInvalid;
      this.corporationData.corporationMobile.value = data.idCardInfo.mobile;
      this.corporationData.liaisonName.value = data.idCardInfo.contacterName;
      this.corporationData.liaisonIdentityCardNo.value = data.idCardInfo.contacterIdcardNum;
      this.corporationData.liaisonMobile.value = data.idCardInfo.contacterMobile;
      this.corporationData.corporationName.sex = data.idCardInfo.sex;
      this.corporationData.corporationName.birthday = data.idCardInfo.birthday;
      this.corporationData.corporationName.nationality = data.idCardInfo.nationality;
      this.corporationData.corporationName.address = data.idCardInfo.address;
      this.corporationData.corporationName.office = data.idCardInfo.office;
      // 银行卡
      this.bankCardData.bankCardType.id = data.collectType;
      this.popup.bankCardTypeArr.forEach(item => (item.selected = false));
      const currentBankCardType = this.popup.bankCardTypeArr.find(item => item.value === data.collectType);
      currentBankCardType.selected = true;
      this.bankCardData.bankCardType.value = currentBankCardType.label;
      this.bankCardData.bankCardPicture.value = data.bankCard.bankCardFrontPicUrl;
      this.bankCardData.accountName.value = data.bankCard.holderName;
      this.bankCardData.bankCardNumber.value = data.bankCard.bankCardNum;
      this.bankCardData.bankName.value = data.bankCard.bankName;
      this.bankCardData.bankArea.value = `${data.bankCard.bankProvinceName} ${data.bankCard.bankCityName}`;
      this.bankCardData.bankSubName.value = data.bankCard.bankFullName;
      this.bankCardData.bankSubName.sbno = data.bankCard.sbNo;
      this.bankCardData.accountMobile.value = data.bankCard.bankPhoneNum;
      this.bankCardData.businessCycle.value = data.bankCard.operatingCycle;
      if (this.bankCardData.bankCardType.id === 1) {
        this.bankCardData.grantBankCardPicture.value = data.bankCard2.authBankCardFrontPicUrl;
        this.bankCardData.grantIdCardPictureFront.value = data.bankCard2.authIdCardFrontUrl;
        this.bankCardData.grantIdCardPictureBack.value = data.bankCard2.authIdCardBackUrl;
        this.bankCardData.grantCertificatePicture.value = data.bankCard2.authorizationPicUrl;
        this.bankCardData.grantCorporationName.value = data.bankCard2.authIdCardName;
        this.bankCardData.grantIdCardNumber.value = data.bankCard2.authIdCardNum;
        this.bankCardData.grantIdCardAddress.value = data.bankCard2.authIdCardAddress;
        this.bankCardData.grantIdCardStartDate.value = data.bankCard2.authDateOfIssue;
        this.bankCardData.grantIdCardEndDate.value = data.bankCard2.authDateOfInvalid;
        this.bankCardData.grantBankCardNumber.value = data.bankCard2.authBankCardNum;
        this.bankCardData.grantBankName.value = data.bankCard2.authBankName;
        this.bankCardData.grantBankSubName.sbno = data.bankCard2.authSbNo;
        this.bankCardData.grantBankSubName.value = data.bankCard2.authBankFullName;
        this.bankCardData.grantBankArea.value = `${data.bankCard2.authBankProvinceName} ${data.bankCard2.authBankCityName}`;
        this.bankCardData.grantAccountMobile.value = data.bankCard2.authBankPhoneNum;
      }
      // 协议
      this.commitmentData.agreementType.id = data.bankCard.agreementType;
      this.popup.agreementTypeArr.forEach(item => (item.selected = false));
      const currentAgreementType = this.popup.agreementTypeArr.find(item => item.value === data.bankCard.agreementType);
      currentAgreementType.selected = true;
      this.commitmentData.agreementType.value = currentAgreementType.label;
      if (this.commitmentData.agreementType.id === 1) {
        if (this.agreementPageCount >= 2) {
          this.commitmentData.agreementFile1Picture.value = data.bankCard.agreementPicUrl[0];
          this.commitmentData.agreementFile2Picture.value = data.bankCard.agreementPicUrl[1];
        }
        if (this.agreementPageCount >= 4) {
          this.commitmentData.agreementFile3Picture.value = data.bankCard.agreementPicUrl[2];
          this.commitmentData.agreementFile4Picture.value = data.bankCard.agreementPicUrl[3];
        }
        if (this.agreementPageCount >= 6) {
          this.commitmentData.agreementFile5Picture.value = data.bankCard.agreementPicUrl[4];
          this.commitmentData.agreementFile6Picture.value = data.bankCard.agreementPicUrl[5];
        }
        // 2022.4.26修改，重新编辑时重新生成协议编号
        this.generateAuthNum(() => {
          this.commitmentData.commitmentNumber.value = this.tmp.commitmentNumber;
        });
        this.commitmentData.commitmentPicture.value = data.authCommitmentPicUrl;
      }
    },
    // 通过接口用缓存中的数组填充页面数
    fillPageAllDataByCache(callback = null) {
      GetCustomerCache({ subjectType: this.currentIntoType })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              // 读取数据
              const data = res.data;
              if (data) {
                CusConfirm('检测到您上次有未完成的信息<br>是否继续？', () => {
                  // 页面状态
                  this.currentTabIndex = data.currentTabIndex;
                  this.tabStatus.selected = data.tabStatusSelected.split('').map(item => {
                    return item === '1';
                  });
                  this.tabStatus.edited = data.tabStatusEdited.split('').map(item => {
                    return item === '1';
                  });
                  this.tabStatus.completed = data.tabStatusCompleted.split('').map(item => {
                    return item === '1';
                  });
                  // 费率
                  this.rateData.normalRate.value = formatRateForShow(data.fee);
                  // 企业
                  // 2022.6.10 添加判断是企业进件时才获取缓存信息的特殊项
                  if (this.currentIntoType === 0) {
                    // 营业执照照片
                    this.companyData.licensePicture.value = data.licensePhoto;
                    // 营业执照类型
                    this.companyData.businessLicenseType.id = data.accountType;
                    this.popup.businessLicenseTypeArr.forEach(item => (item.selected = false));
                    const currentBusinessLicenseType = this.popup.businessLicenseTypeArr.find(item => item.value === data.accountType);
                    this.companyData.businessLicenseType.value = currentBusinessLicenseType.label;
                    currentBusinessLicenseType.selected = true;
                    // 业执照注册号
                    this.companyData.licenseNumber.value = data.businessLicense;
                    // 营业执照生效日期
                    this.companyData.licenceStartDate.value = data.licenceStartDate;
                    // 营业执照有效期
                    this.companyData.licenseValidDate.value = data.licenceValidDate;
                    // 店铺经营范围
                    this.companyData.licenseScope.value = data.businessScope;
                    // 公司经营名称(选填)
                    this.companyData.companyLicenseName.value = data.companyBusinessName;
                    // 公司英文名称(选填)
                    this.companyData.companyEnglishName.value = data.companyEnglishName;
                  }
                  this.companyData.shopPicture.value = data.storeHeaderImgUrl;
                  this.companyData.placePicture.value = data.storeIndoorImgUrl;
                  this.companyData.cashierPicture.value = data.storeCashierImgUrl;
                  this.companyData.other1Picture.value = data.otherImg1;
                  this.companyData.other2Picture.value = data.otherImg2;
                  this.companyData.tradeType.value = data.industryText;
                  this.companyData.tradeType.id = data.industryId;
                  this.companyData.companyName.value = data.companyName;
                  this.companyData.companyShortName.value = data.companyShortName; // 2022.8.18 简称
                  this.companyData.companyProvince.value = data.provinceText;
                  this.companyData.companyProvince.id = data.provinceId;
                  this.companyData.companyCity.value = data.cityText;
                  this.companyData.companyCity.id = data.cityId;
                  this.companyData.companyArea.value = data.countyText;
                  this.companyData.companyArea.id = data.countyId;
                  this.companyData.companyAddress.value = data.companyAddress;
                  // 法人
                  this.corporationData.identityCardPictureFront.value = data.idCardFrontUrl;
                  this.corporationData.identityCardPictureBack.value = data.idCardBackUrl;
                  this.corporationData.corporationName.value = data.idCardName;
                  this.corporationData.identityCardNumber.value = data.idCardNum;
                  this.corporationData.identityCardStartDate.value = data.dateOfIssue;
                  this.corporationData.identityCardEndDate.value = data.dateOfInvalid;
                  this.corporationData.corporationMobile.value = data.mobile;
                  this.corporationData.liaisonName.value = data.contacterName;
                  this.corporationData.liaisonIdentityCardNo.value = data.contacterIdcardNum;
                  this.corporationData.liaisonMobile.value = data.contacterMobile;
                  this.corporationData.corporationName.sex = data.sex;
                  this.corporationData.corporationName.birthday = data.birthday;
                  this.corporationData.corporationName.nationality = data.nationality;
                  this.corporationData.corporationName.address = data.address;
                  this.corporationData.corporationName.office = data.office;
                  // 银行卡
                  this.bankCardData.bankCardType.id = data.collectType;
                  this.popup.bankCardTypeArr.forEach(item => (item.selected = false));
                  const currentBankCardType = this.popup.bankCardTypeArr.find(item => item.value === data.collectType);
                  currentBankCardType.selected = true;
                  this.bankCardData.bankCardType.value = currentBankCardType.label;
                  this.bankCardData.bankCardPicture.value = data.bankCardFrontPicUrl;
                  this.bankCardData.accountName.value = data.holderName;
                  this.bankCardData.bankCardNumber.value = data.bankCardNum;
                  this.bankCardData.bankName.value = data.bankName;
                  this.bankCardData.bankArea.value = data.bankCityName !== '' ? `${data.bankProvinceName} ${data.bankCityName}` : data.bankProvinceName;
                  this.bankCardData.bankSubName.value = data.bankFullName;
                  this.bankCardData.bankSubName.sbno = data.sbNo;
                  this.bankCardData.accountMobile.value = data.bankPhoneNum;
                  this.bankCardData.businessCycle.value = data.operatingCycle;
                  if (this.bankCardData.bankCardType.id === 1) {
                    this.bankCardData.grantBankCardPicture.value = data.authBankCardFrontPicUrl;
                    this.bankCardData.grantIdCardPictureFront.value = data.authIdCardFrontUrl;
                    this.bankCardData.grantIdCardPictureBack.value = data.authIdCardBackUrl;
                    this.bankCardData.grantCertificatePicture.value = data.authorizationPicUrl;
                    this.bankCardData.grantCorporationName.value = data.authIdCardName;
                    this.bankCardData.grantIdCardNumber.value = data.authIdCardNum;
                    this.bankCardData.grantIdCardAddress.value = data.authIdCardAddress;
                    this.bankCardData.grantIdCardStartDate.value = data.authDateOfIssue;
                    this.bankCardData.grantIdCardEndDate.value = data.authDateOfInvalid;
                    this.bankCardData.grantBankCardNumber.value = data.authBankCardNum;
                    this.bankCardData.grantBankName.value = data.authBankName;
                    this.bankCardData.grantBankSubName.sbno = data.authSbNo;
                    this.bankCardData.grantBankSubName.value = data.authBankFullName;
                    this.bankCardData.grantBankArea.value = data.authBankCityName !== '' ? `${data.authBankProvinceName} ${data.authBankCityName}` : data.authBankProvinceName;
                    this.bankCardData.grantAccountMobile.value = data.authBankPhoneNum;
                  }
                  // 协议
                  this.commitmentData.agreementType.id = data.agreementType;
                  this.popup.agreementTypeArr.forEach(item => (item.selected = false));
                  const currentAgreementType = this.popup.agreementTypeArr.find(item => item.value === data.agreementType);
                  currentAgreementType.selected = true;
                  this.commitmentData.agreementType.value = currentAgreementType.label;
                  if (this.commitmentData.agreementType.id === 1) {
                    if (this.agreementPageCount >= 2) {
                      this.commitmentData.agreementFile1Picture.value = data.agreementPicUrl[0];
                      this.commitmentData.agreementFile2Picture.value = data.agreementPicUrl[1];
                    }
                    if (this.agreementPageCount >= 4) {
                      this.commitmentData.agreementFile3Picture.value = data.agreementPicUrl[2];
                      this.commitmentData.agreementFile4Picture.value = data.agreementPicUrl[3];
                    }
                    if (this.agreementPageCount >= 6) {
                      this.commitmentData.agreementFile5Picture.value = data.agreementPicUrl[4];
                      this.commitmentData.agreementFile6Picture.value = data.agreementPicUrl[5];
                    }
                    this.commitmentData.commitmentNumber.value = data.authNumber;
                    this.commitmentData.commitmentPicture.value = data.authCommitmentPicUrl;
                  }
                });
              }
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 返回的图片信息
    getCameraImgInfo(info) {
      upLoadImgForAgent(info.blob, info.base64, info.type, res => {
        switch (info.type) {
          case 'licensePicture':
            this.companyData.licensePicture.value = res.data;
            this.getBusinessLicenseInfo(res.data);
            break;
          case 'shopPicture':
            this.companyData.shopPicture.value = res.data;
            break;
          case 'placePicture':
            this.companyData.placePicture.value = res.data;
            break;
          case 'cashierPicture':
            this.companyData.cashierPicture.value = res.data;
            break;
          case 'renXiang':
            this.corporationData.identityCardPictureFront.value = res.data;
            this.getIdCardInformation(res.data, 1, 'corporation');
            break;
          case 'guoHui':
            this.corporationData.identityCardPictureBack.value = res.data;
            this.getIdCardInformation(res.data, 2, 'corporation');
            break;
          case 'bankCardPicture':
            this.bankCardData.bankCardPicture.value = res.data;
            this.getBankCardInformation(res.data, 'normal');
            break;
          case 'grantRenXiang':
            this.bankCardData.grantIdCardPictureFront.value = res.data;
            this.getIdCardInformation(res.data, 1, 'bankCard');
            break;
          case 'grantGuoHui':
            this.bankCardData.grantIdCardPictureBack.value = res.data;
            this.getIdCardInformation(res.data, 2, 'bankCard');
            break;
          case 'grantBankCardPicture':
            this.bankCardData.grantBankCardPicture.value = res.data;
            this.getBankCardInformation(res.data, 'grant');
            break;
          case 'commitmentPicture':
            this.commitmentData.commitmentPicture.value = res.data;
            break;
          case 'agreementFile1':
            this.commitmentData.agreementFile1Picture.value = res.data;
            break;
          case 'agreementFile2':
            this.commitmentData.agreementFile2Picture.value = res.data;
            break;
          case 'agreementFile3':
            this.commitmentData.agreementFile3Picture.value = res.data;
            break;
          case 'agreementFile4':
            this.commitmentData.agreementFile4Picture.value = res.data;
            break;
          case 'agreementFile5':
            this.commitmentData.agreementFile5Picture.value = res.data;
            break;
          case 'agreementFile6':
            this.commitmentData.agreementFile6Picture.value = res.data;
            break;
          case 'other1Picture':
            this.companyData.other1Picture.value = res.data;
            break;
          case 'other2Picture':
            this.companyData.other2Picture.value = res.data;
            break;
        }
      });
    },
    // 验证当前页面数据的合法性
    validatePageData(pageIndex, callback = null) {
      // 验证-费率
      if (pageIndex === 0) {
        const normalRateErr = validateRate(this.rateData.normalRate.value);
        const nomalRateMinMaxErr = validateMinMax(this.rateData.normalRate.value, this.tmp.minFee, this.tmp.maxFee);
        if (!normalRateErr && !nomalRateMinMaxErr) {
          callback && callback();
        } else {
          if (normalRateErr === 1) {
            CusToast('费率不能为空');
            return;
          }
          if (normalRateErr === 2) {
            CusToast('请输入合法的费率值');
            return;
          }
          if (normalRateErr === 3) {
            CusToast('费率只能保留两位小数');
            return;
          }
          if (nomalRateMinMaxErr === 1) {
            CusToast(`费率不能高于${this.tmp.maxFee}（万分之）`);
            return;
          }
          if (nomalRateMinMaxErr === 2) {
            CusToast(`费率不能低于${this.tmp.minFee}（万分之）`);
            return;
          }
        }
      }
      // 验证-公司(营业执照)
      if (pageIndex === 1 && this.currentIntoType === 0) {
        // 验证
        const licenseTypeErr = validateEmpty(this.companyData.licenseType.value);
        const licensePictureErr = validateEmpty(this.companyData.licensePicture.value);
        const shopPictureErr = validateEmpty(this.companyData.shopPicture.value);
        const placePictureErr = validateEmpty(this.companyData.placePicture.value);
        const cashierPictureErr = validateEmpty(this.companyData.cashierPicture.value);
        const tradeTypeErr = validateEmpty(this.companyData.tradeType.value);
        const licenseScopeErr = validateEmpty(this.companyData.licenseScope.value);
        const licenseNumberErr = validateLicenseNo2(this.companyData.licenseNumber.value);
        const licenceStartDateErr = validateEmpty(this.companyData.licenceStartDate.value);
        const licenseValidDateErr = validateEmpty(this.companyData.licenseValidDate.value);
        const companyNameErr = validateEmpty(this.companyData.companyName.value);
        const companyProvinceErr = validateEmpty(this.companyData.companyProvince.value);
        const companyCityErr = validateEmpty(this.companyData.companyCity.value);
        const companyAreaErr = validateEmpty(this.companyData.companyArea.value);
        const companyAddressErr = validateEmpty(this.companyData.companyAddress.value);
        const businessLicenseTypeErr = validateEmpty(this.companyData.businessLicenseType.value);

        const errResult1 = !licenseTypeErr && !licensePictureErr && !shopPictureErr;
        const errResult2 = !placePictureErr && !cashierPictureErr && !tradeTypeErr;
        const errResult3 = !licenseScopeErr && !licenseNumberErr && !companyNameErr;
        const errResult4 = !companyProvinceErr && !companyCityErr && !companyAreaErr;
        const errResult5 = !companyAddressErr && !licenceStartDateErr && !licenseValidDateErr;
        const errResult6 = !businessLicenseTypeErr;

        if (errResult1 && errResult2 && errResult3 && errResult4 && errResult5 && errResult6) {
          // 2022.06.07 将验证营业执照法人和手填法人是否一致的逻辑从点击法人资料页面提交按钮挪到此处
          this.validateCompanyPerson(() => {
            // 2022.05.07 新加异步验证营业执照黑名单
            // 2022.05.24 新加校验当前公司名称是否合法
            // 2022.06.08 新加校验当前公司地址是否合法
            // 2022.05.27 新加校验当前公司营业执照开始时间
            // 2022.06.07 新加校验当前公司所在区域是否合法
            CusLoadingOpen();
            this.queryBlackList(2, this.companyData.licenseNumber.value, () => {
              this.isLegitimacyForCompanyName(this.companyData.companyName.value, this.companyData.companyShortName.value, () => {
                this.isLegitimacyForCompanyAddress(this.companyData.companyAddress.value, () => {
                  this.businessStartDateParse(this.companyData.licenceStartDate.value, () => {
                    this.isLegitimacyForCompanyArea(this.companyData.companyProvince.id, this.companyData.companyCity.id, this.companyData.companyArea.id, () => {
                      CusLoadingClose();
                      callback && callback();
                    });
                  });
                });
              });
            });
          });
        } else {
          if (licenseTypeErr) {
            CusToast('证件照类型不能为空');
            return;
          }
          if (licensePictureErr) {
            CusToast('必须上传营业执照照片');
            return;
          }
          if (shopPictureErr) {
            CusToast('必须上传店铺门头照片');
            return;
          }
          if (placePictureErr) {
            CusToast('必须上传经营场所照片');
            return;
          }
          if (cashierPictureErr) {
            CusToast('必须上传收银台照片');
            return;
          }
          if (businessLicenseTypeErr) {
            CusToast('营业执照类型不能为空');
            return;
          }
          if (licenseNumberErr === 1) {
            CusToast('营业执照注册号不能为空');
            return;
          }
          if (licenseNumberErr === 2) {
            CusToast('营业执照注册号格式错误');
            return;
          }
          if (companyNameErr) {
            CusToast('公司名称不能为空');
            return;
          }
          if (companyAddressErr) {
            CusToast('详细地址不能为空');
            return;
          }
          if (licenceStartDateErr) {
            CusToast('营业执照生效日期不能为空');
            return;
          }
          if (licenseValidDateErr) {
            CusToast('营业执照有效期不能为空');
            return;
          }
          if (licenseScopeErr) {
            CusToast('店铺经营范围不能为空');
            return;
          }
          if (tradeTypeErr) {
            CusToast('所属行业不能为空');
            return;
          }
          if (companyProvinceErr) {
            CusToast('所在省份不能为空');
            return;
          }
          if (companyCityErr) {
            CusToast('所在城市不能为空');
            return;
          }
          if (companyAreaErr) {
            CusToast('所在地区不能为空');
            return;
          }
        }
      }
      // 验证-公司(小微商户)
      if (pageIndex === 1 && this.currentIntoType === 1) {
        // 验证
        const shopPictureErr = validateEmpty(this.companyData.shopPicture.value);
        const placePictureErr = validateEmpty(this.companyData.placePicture.value);
        const cashierPictureErr = validateEmpty(this.companyData.cashierPicture.value);
        const tradeTypeErr = validateEmpty(this.companyData.tradeType.value);
        const companyNameErr = validateXwCompanyName(this.companyData.companyName.value, this.tmp.xwCompanyMin);
        const companyProvinceErr = validateEmpty(this.companyData.companyProvince.value);
        const companyCityErr = validateEmpty(this.companyData.companyCity.value);
        const companyAreaErr = validateEmpty(this.companyData.companyArea.value);
        const companyAddressErr = validateEmpty(this.companyData.companyAddress.value);

        const errResult1 = !shopPictureErr && !placePictureErr && !cashierPictureErr && !tradeTypeErr;
        const errResult2 = !companyNameErr && !companyProvinceErr && !companyCityErr && !companyAreaErr;
        const errResult3 = !companyAddressErr;

        if (errResult1 && errResult2 && errResult3) {
          // 2022.05.24 新加校验当前公司名称是否合法
          // 2022.06.08 新加校验当前公司地址是否合法
          // 2022.06.07 新加校验当前公司所在区域是否合法
          CusLoadingOpen();
          this.isLegitimacyForCompanyName(this.companyData.companyName.value, this.companyData.companyShortName.value, () => {
            this.isLegitimacyForCompanyAddress(this.companyData.companyAddress.value, () => {
              this.isLegitimacyForCompanyArea(this.companyData.companyProvince.id, this.companyData.companyCity.id, this.companyData.companyArea.id, () => {
                CusLoadingClose();
                callback && callback();
              });
            });
          });
        } else {
          if (shopPictureErr) {
            CusToast('必须上传店铺门头照片');
            return;
          }
          if (placePictureErr) {
            CusToast('必须上传经营场所照片');
            return;
          }
          if (cashierPictureErr) {
            CusToast('必须上传收银台照片');
            return;
          }
          if (companyNameErr === 1) {
            CusToast('公司名称不能为空');
            return;
          }
          if (companyNameErr === 2) {
            CusToast(`公司名称至少需要${this.tmp.xwCompanyMin}个字`);
            return;
          }
          if (companyAddressErr) {
            CusToast('详细地址不能为空');
            return;
          }
          if (tradeTypeErr) {
            CusToast('所属行业不能为空');
            return;
          }
          if (companyProvinceErr) {
            CusToast('所在省份不能为空');
            return;
          }
          if (companyCityErr) {
            CusToast('所在城市不能为空');
            return;
          }
          if (companyAreaErr) {
            CusToast('所在地区不能为空');
            return;
          }
        }
      }
      // 验证-法人
      if (pageIndex === 2) {
        // 验证
        const identityTypeErr = validateEmpty(this.corporationData.identityType.value);
        const identityCardPictureFrontErr = validateEmpty(this.corporationData.identityCardPictureFront.value);
        const identityCardPictureBackErr = validateEmpty(this.corporationData.identityCardPictureBack.value);
        const corporationNameErr = validateEmpty(this.corporationData.corporationName.value);
        const identityCardNumberErr = validateIdCard(this.corporationData.identityCardNumber.value);
        const identityCardStartDateErr = validateEmpty(this.corporationData.identityCardStartDate.value);
        const identityCardEndDateErr = validateEmpty(this.corporationData.identityCardEndDate.value);
        const corporationMobileErr = validateMobile(this.corporationData.corporationMobile.value);

        const errResult1 = !identityTypeErr && !identityCardPictureFrontErr && !identityCardPictureBackErr;
        const errResult2 = !corporationNameErr && !identityCardNumberErr && !identityCardStartDateErr;
        const errResult3 = !identityCardEndDateErr && !corporationMobileErr;

        if (errResult1 && errResult2 && errResult3) {
          // 2022.6.7 将验证营业执照法人和手填法人是否一致的逻辑从点击法人资料页面提交按钮挪到此处
          this.validateCompanyPerson(() => {
            // 2022.5.7 新加法人身份证黑名单
            CusLoadingOpen();
            this.queryBlackList(1, this.corporationData.identityCardNumber.value, () => {
              // 2022.5.20 添加当前身份证号注册数量是否超限
              this.isReachedMaximumLimitByIdCardNum(this.corporationData.identityCardNumber.value.replace(/\s/gi, ''), () => {
                CusLoadingClose();
                callback && callback();
              });
            });
          });
        } else {
          if (identityTypeErr) {
            CusToast('法人证件类型不能为空');
            return;
          }
          if (identityCardPictureFrontErr) {
            CusToast('请上传法人证件照头像面照片');
            return;
          }
          if (identityCardPictureBackErr) {
            CusToast('请上传法人证件照国徽面照片');
            return;
          }
          if (corporationNameErr) {
            CusToast('法人姓名不能为空');
            return;
          }
          if (identityCardNumberErr === 1) {
            CusToast('法人证件号不能为空');
            return;
          }
          if (identityCardNumberErr === 2) {
            CusToast('法人证件号格式不正确');
            return;
          }
          if (identityCardStartDateErr) {
            CusToast('证件有效开始日期不能为空');
            return;
          }
          if (identityCardEndDateErr) {
            CusToast('证件有效截止日期不能为空');
            return;
          }
          if (corporationMobileErr === 1) {
            CusToast('法人手机号不能为空');
            return;
          }
          if (corporationMobileErr === 2) {
            CusToast('法人手机号格式不正确');
            return;
          }
        }
      }
      // 验证收款
      if (pageIndex === 3) {
        // 验证
        const bankCardTypeErr = validateEmpty(this.bankCardData.bankCardType.value);
        const bankCardPictureErr = validateEmpty(this.bankCardData.bankCardPicture.value);
        const accountNameErr = validateEmpty(this.bankCardData.accountName.value);
        const bankCardNumberErr = validateBankCard(this.bankCardData.bankCardNumber.value);
        const bankCardNumberTypeErr = this.bankCardData.bankCardNumber.type === 2;
        const bankNameErr = validateEmpty(this.bankCardData.bankName.value);
        const bankAreaErr = validateEmpty(this.bankCardData.bankArea.value);
        const bankSubNameErr = validateEmpty(this.bankCardData.bankSubName.value);
        const accountMobileErr = validateMobile(this.bankCardData.accountMobile.value);
        const grantIdCardPictureFrontErr = validateEmpty(this.bankCardData.grantIdCardPictureFront.value);
        const grantIdCardPictureBackErr = validateEmpty(this.bankCardData.grantIdCardPictureBack.value);
        const grantCorporationNameErr = validateEmpty(this.bankCardData.grantCorporationName.value);
        const grantIdCardNumberErr = validateIdCard(this.bankCardData.grantIdCardNumber.value);
        const grantIdCardStartDateErr = validateEmpty(this.bankCardData.grantIdCardStartDate.value);
        const grantIdCardEndDateErr = validateEmpty(this.bankCardData.grantIdCardEndDate.value);
        const grantBankCardPictureErr = validateEmpty(this.bankCardData.grantBankCardPicture.value);
        const grantBankCardNumberErr = validateBankCard(this.bankCardData.grantBankCardNumber.value);
        const grantBankCardNumberTypeErr = this.bankCardData.grantBankCardNumber.type === 2;
        const grantBankNameErr = validateEmpty(this.bankCardData.grantBankName.value);
        const grantBankAreaErr = validateEmpty(this.bankCardData.grantBankArea.value);
        const grantBankSubNameErr = validateEmpty(this.bankCardData.grantBankSubName.value);
        const grantAccountMobileErr = validateMobile(this.bankCardData.grantAccountMobile.value);
        const grantIdCardAddressErr = validateEmpty(this.bankCardData.grantIdCardAddress.value);

        const errResult1 = !bankCardTypeErr && !bankCardPictureErr && !accountNameErr;
        const errResult2 = !bankCardNumberErr && !bankCardNumberTypeErr && !bankNameErr && !bankAreaErr;
        const errResult3 = !bankSubNameErr && !accountMobileErr;
        const errResult4 = !grantIdCardPictureFrontErr && !grantIdCardPictureBackErr && !grantCorporationNameErr;
        const errResult5 = !grantIdCardNumberErr && !grantIdCardStartDateErr && !grantIdCardEndDateErr && !grantIdCardAddressErr;
        const errResult6 = !grantBankCardPictureErr && !grantBankCardNumberErr && !grantBankCardNumberTypeErr;
        const errResult7 = !grantBankNameErr && !grantBankAreaErr && !grantBankSubNameErr && !grantAccountMobileErr;

        if (errResult1 && errResult2 && errResult3) {
          if (this.bankCardData.bankCardType.id === 1) {
            if (errResult4 && errResult5 && errResult6 && errResult7) {
              callback && callback();
            } else {
              if (grantIdCardPictureFrontErr) {
                CusToast('请上传被授权人证件照头像面照片');
                return;
              }
              if (grantIdCardPictureBackErr) {
                CusToast('请上传被授权人证件照国徽面照片');
                return;
              }
              if (grantCorporationNameErr) {
                CusToast('被授权人姓名不能为空');
                return;
              }
              if (grantIdCardNumberErr === 1) {
                CusToast('被授权人证件号不能为空');
                return;
              }
              if (grantIdCardNumberErr === 2) {
                CusToast('被授权人证件号格式不正确');
                return;
              }
              if (grantIdCardAddressErr) {
                CusToast('被授权人住址不能为空');
                return;
              }
              if (grantIdCardStartDateErr) {
                CusToast('被授权人证件有效开始日期不能为空');
                return;
              }
              if (grantIdCardEndDateErr) {
                CusToast('被授权人证件有效截止日期不能为空');
                return;
              }
              if (grantBankCardPictureErr) {
                CusToast('请上传被授权人银行卡照片');
                return;
              }
              if (grantBankCardNumberErr === 1) {
                CusToast('被授权人银行卡号不能为空');
                return;
              }
              if (grantBankCardNumberErr === 2) {
                CusToast('被授权人银行卡号长度必须在16到19之间');
                return;
              }
              if (grantBankCardNumberErr === 3) {
                CusToast('被授权人银行卡号开头6位不符合规范');
                return;
              }
              if (grantBankCardNumberTypeErr) {
                CusToast('被授权人银行卡只能是储蓄卡');
                return;
              }
              if (grantBankNameErr) {
                CusToast('被授权人银行卡所属银行不能为空');
                return;
              }
              if (grantBankAreaErr) {
                CusToast('被授权人银行卡开户地区不能为空');
                return;
              }
              if (grantBankSubNameErr) {
                CusToast('被授权人银行卡开户行不能为空');
                return;
              }
              if (grantAccountMobileErr === 1) {
                CusToast('被授权人银行预留手机号不能为空');
                return;
              }
              if (grantAccountMobileErr === 2) {
                CusToast('被授权人银行预留手机号格式不正确');
                return;
              }
            }
          } else {
            callback && callback();
          }
        } else {
          if (bankCardTypeErr) {
            CusToast('收款方式不能为空');
            return;
          }
          if (bankCardPictureErr) {
            CusToast('请上传银行卡照片');
            return;
          }
          if (accountNameErr) {
            CusToast('开户姓名不能为空');
            return;
          }
          if (bankCardNumberErr === 1) {
            CusToast('银行卡号不能为空');
            return;
          }
          if (bankCardNumberErr === 2) {
            CusToast('银行卡号长度必须在16到19之间');
            return;
          }
          if (bankCardNumberErr === 3) {
            CusToast('银行卡号开头6位不符合规范');
            return;
          }
          if (bankCardNumberTypeErr) {
            CusToast('银行卡只能是储蓄卡');
            return;
          }
          if (bankNameErr) {
            CusToast('所属银行不能为空');
            return;
          }
          if (bankAreaErr) {
            CusToast('开户地区不能为空');
            return;
          }
          if (bankSubNameErr) {
            CusToast('开户行不能为空');
            return;
          }
          if (accountMobileErr === 1) {
            CusToast('银行预留手机号不能为空');
            return;
          }
          if (accountMobileErr === 2) {
            CusToast('银行预留手机号格式不正确');
            return;
          }
        }
      }
      // 验证授权
      if (pageIndex === 4) {
        // 验证
        // 纸质协议才判断
        if (this.commitmentData.agreementType.id === 1) {
          const agreementFile1PictureErr = validateEmpty(this.commitmentData.agreementFile1Picture.value);
          const agreementFile2PictureErr = validateEmpty(this.commitmentData.agreementFile2Picture.value);
          const agreementFile3PictureErr = validateEmpty(this.commitmentData.agreementFile3Picture.value);
          const agreementFile4PictureErr = validateEmpty(this.commitmentData.agreementFile4Picture.value);
          const agreementFile5PictureErr = validateEmpty(this.commitmentData.agreementFile5Picture.value);
          const agreementFile6PictureErr = validateEmpty(this.commitmentData.agreementFile6Picture.value);
          const commitmentPictureErr = validateEmpty(this.commitmentData.commitmentPicture.value);
          const errResult1 = !agreementFile1PictureErr && !agreementFile2PictureErr;
          const errResult2 = !agreementFile3PictureErr && !agreementFile4PictureErr;
          const errResult3 = !agreementFile5PictureErr && !agreementFile6PictureErr;
          const errResult4 = !commitmentPictureErr;
          if (this.agreementPageCount === 2) {
            if (errResult1 && errResult4) {
              callback && callback();
            } else {
              if (agreementFile1PictureErr) {
                CusToast('请上传协议第1页的照片');
                return;
              }
              if (agreementFile2PictureErr) {
                CusToast('请上传协议第2页的照片');
                return;
              }
              if (commitmentPictureErr) {
                CusToast('请上传承诺函照片');
                return;
              }
            }
          }
          if (this.agreementPageCount === 4) {
            if (errResult1 && errResult2 && errResult4) {
              callback && callback();
            } else {
              if (agreementFile1PictureErr) {
                CusToast('请上传协议第1页的照片');
                return;
              }
              if (agreementFile2PictureErr) {
                CusToast('请上传协议第2页的照片');
                return;
              }
              if (agreementFile3PictureErr) {
                CusToast('请上传协议第3页的照片');
                return;
              }
              if (agreementFile4PictureErr) {
                CusToast('请上传协议第4页的照片');
                return;
              }
              if (commitmentPictureErr) {
                CusToast('请上传承诺函照片');
                return;
              }
            }
          }
          if (this.agreementPageCount === 6) {
            if (errResult1 && errResult2 && errResult3 && errResult4) {
              callback && callback();
            } else {
              if (agreementFile1PictureErr) {
                CusToast('请上传协议第1页的照片');
                return;
              }
              if (agreementFile2PictureErr) {
                CusToast('请上传协议第2页的照片');
                return;
              }
              if (agreementFile3PictureErr) {
                CusToast('请上传协议第3页的照片');
                return;
              }
              if (agreementFile4PictureErr) {
                CusToast('请上传协议第4页的照片');
                return;
              }
              if (agreementFile5PictureErr) {
                CusToast('请上传协议第5页的照片');
                return;
              }
              if (agreementFile6PictureErr) {
                CusToast('请上传协议第6页的照片');
                return;
              }
              if (commitmentPictureErr) {
                CusToast('请上传承诺函照片');
                return;
              }
            }
          }
        } else {
          callback && callback();
        }
      }
    },
    // 验证营业执照法人和手填法人是否一致
    validateCompanyPerson(callback = null) {
      const person = this.companyData.licenseNumber.person;
      const cName = this.corporationData.corporationName.value;
      if (person && person !== '无' && cName && cName !== '无') {
        if (cName === person) {
          callback && callback();
        } else {
          CusToast('法人姓名与营业执照上法人姓名不一致');
        }
      } else {
        callback && callback();
      }
      // callback && callback();
    },
    // 设置topbar选中状态
    setTabSelectedStatus(index) {
      // 设置topbar选中样式
      this.tabStatus.selected = this.tabStatus.selected.map(item => (item = false));
      this.tabStatus.selected[index] = true;
      this.currentTabIndex = index;
    },
    // 设置长备选项查询窗口的查询事件
    setPopupSearchBarHandler() {
      // 2022.6.21 将长备选项页面的查询组件中取消按钮改为查询按钮
      this.popup.searchBar.input = this.$refs.searchBar.$el.querySelectorAll('.mint-searchbar-core')[0];
      this.popup.searchBar.cancel = this.$refs.searchBar.$el.querySelectorAll('.mint-searchbar-cancel')[0];
      this.popup.searchBar.input.addEventListener('input', this.customSearchBarInputEvent);
      this.popup.searchBar.cancel.addEventListener('click', this.customSearchBarClickEvent);
    },
    // 设置长备选项查询窗口的子窗口的查询事件
    setPopupSearchSubBarHandler() {
      // 2022.6.21 将长备选项页面的查询组件中取消按钮改为查询按钮
      this.popup.searchSubBar.input = this.$refs.searchSubBar.$el.querySelectorAll('.mint-searchbar-core')[0];
      this.popup.searchSubBar.cancel = this.$refs.searchSubBar.$el.querySelectorAll('.mint-searchbar-cancel')[0];
      this.popup.searchSubBar.input.addEventListener('input', this.customSearchSubBarInputEvent);
      this.popup.searchSubBar.cancel.addEventListener('click', this.customSearchSubBarClickEvent);
    },
    // 自定义mintui中search组件的input的事件
    customSearchBarInputEvent() {
      this.popup.searchInputKey = this.popup.searchBar.input.value;
    },
    // 自定义mintui中search组件的input的事件
    customSearchSubBarInputEvent() {
      this.popup.searchSubInputKey = this.popup.searchSubBar.input.value;
    },
    // 自定义mintui中search组件的click的事件
    customSearchBarClickEvent() {
      this.popup.searchBar.cancel.style = 'display:block;';
      this.popup.searchKey = this.popup.searchInputKey;
      switch (this.popup.parent) {
        case 'tradeType':
        case 'bankName':
        case 'grantBankName':
          this.onPopupSearchKeyup();
          break;
      }
    },
    // 自定义mintui中search组件的click的事件
    customSearchSubBarClickEvent() {
      this.popup.searchSubBar.cancel.style = 'display:block;';
      this.popup.searchSubKey = this.popup.searchSubInputKey;
    },
    // 跳转信息添加页面
    onBackBtnClick() {
      this.$router.go(-1);
    },
    // 顶部tab点击事件
    onTabClick(index) {
      this.$nextTick(() => {
        // 先判断不能选中当前已经选定的页面
        if (!this.tabStatus.selected[index]) {
          // 再判断要选中的页面是否可以编辑，不可编辑不能选中
          if (this.tabStatus.edited[index]) {
            // 最后在切换当前tab之前，对当前页面数据数据进行验证
            if (this.tabStatus.completed[this.currentTabIndex]) {
              this.validatePageData(this.currentTabIndex, () => {
                this.setTabSelectedStatus(index);
              });
            } else {
              // 2022.6.8 新加如果当前页面是法人资料，需要验证一下法人姓名和营业执照上是否一致
              if (this.currentTabIndex === 2) {
                this.validatePageData(this.currentTabIndex, () => {
                  this.setTabSelectedStatus(index);
                });
              } else {
                this.setTabSelectedStatus(index);
              }
            }
          } else {
            CusToast('请完善当前页面信息');
          }
        }
      });
    },
    // 设置费率-费率输入事件
    onNormalRateInput() {
      this.rateData.normalRate.value = controlRateInput(this.rateData.normalRate.value);
    },
    // 企业资料-营业执照号输入事件
    onLicenseNumberInput() {
      this.companyData.licenseNumber.value = controlLicenseNoInput(this.companyData.licenseNumber.value);
    },
    // 企业资料-公司名称输入事件
    onCompanyNameInput() {
      this.companyData.companyName.value = controlCompanyNameInput(this.companyData.companyName.value);
    },
    // 企业资料-公司简称输入事件
    onCompanyShortNameInput() {
      this.companyData.companyShortName.value = controlCompanyNameInput(this.companyData.companyShortName.value);
    },
    // 法人资料-法人身份证输入事件
    onIdentityCardNumberInput() {
      this.corporationData.identityCardNumber.value = controlIdCardInput(this.corporationData.identityCardNumber.value);
    },
    // 法人资料-法人手机号输入事件
    onCorporationMobileInput() {
      this.corporationData.corporationMobile.value = controlMobileInput(this.corporationData.corporationMobile.value);
    },
    // 收款资料-银行卡号输入事件
    onBankCardNumberInput() {
      this.$nextTick(() => {
        this.bankCardData.bankCardNumber.value = controlBankCardInput(this.bankCardData.bankCardNumber.value);
        const currentNumber = this.bankCardData.bankCardNumber.value.replace(/\s/gi, '');
        if (currentNumber.length === 16 || currentNumber.length === 19) {
          this.getSBNOByCardNum(currentNumber, 'normal');
        }
      });
    },
    // 收款资料-开户人手机号输入事件
    onAccountMobileInput() {
      this.bankCardData.accountMobile.value = controlMobileInput(this.bankCardData.accountMobile.value);
    },
    // 收款资料-被授权人证件号输入事件
    onGrantIdCardNumberInput() {
      this.bankCardData.grantIdCardNumber.value = controlIdCardInput(this.bankCardData.grantIdCardNumber.value);
    },
    // 收款资料-被授权人银行卡号输入事件
    onGrantBankCardNumberInput() {
      this.$nextTick(() => {
        this.bankCardData.grantBankCardNumber.value = controlBankCardInput(this.bankCardData.grantBankCardNumber.value);
        const currentNumber = this.bankCardData.grantBankCardNumber.value.replace(/\s/gi, '');
        if (currentNumber.length === 16 || currentNumber.length === 19) {
          this.getSBNOByCardNum(currentNumber, 'grant');
        }
      });
    },
    // 收款资料-被授权人开户人手机号输入事件
    onGrantAccountMobileInput() {
      this.bankCardData.grantAccountMobile.value = controlMobileInput(this.bankCardData.grantAccountMobile.value);
    },
    // 收款资料-工商预留手机号输入事件
    onLicenseMobileInput() {
      this.companyData.licenseMobile.value = controlMobileInput(this.companyData.licenseMobile.value);
    },
    // 证件照类型点击事件
    onLicenseTypeClick() {
      if (this.companyData.licenseType.mult) {
        return;
      }
    },
    // 营业执照类型点击事件
    onBusinessLicenseTypeClick() {
      if (this.companyData.businessLicenseType.mult) {
        this.popup.type = 1;
        this.popup.title = '选择营业执照类型';
        this.popup.parent = 'businessLicenseType';
      }
      this.$nextTick(() => {
        this.popup.visible = true;
      });
    },
    // 法人证件类型点击事件
    onIdentityTypeClick() {
      if (this.corporationData.identityType.mult) {
        return;
      }
    },
    // 法人证件日期点击事件
    onDatePickerItemClick(val) {
      this.picker.parent = val;
      switch (val) {
        // 身份证/营业执照-开始日期
        case 'identityCardStartDate':
        case 'grantIdCardStartDate':
        case 'licenceStartDate':
          // 日期框显示的最大日期：1900-01-01
          this.picker.startDate = new Date('1900-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          break;
        // 身份证/营业执照-结束日期
        case 'identityCardEndDate':
        case 'grantIdCardEndDate':
        case 'licenseValidDate':
          // 日期框显示的最大日期：今天
          this.picker.startDate = new Date();
          // 日期框显示的最小日期：2305-12-31
          this.picker.endDate = new Date('2355-12-31');
          break;
      }
      this.$refs.datePicker.open();
    },
    // 营业执照日期长期按钮点击事件
    onLicenseValidDateBtnClick() {
      this.companyData.licenseValidDate.value = '长期';
    },
    // 法人证件日期长期按钮点击事件
    onIdCardEndDateBtnClick() {
      this.corporationData.identityCardEndDate.value = '长期';
    },
    // 被授权人证件日期长期按钮点击事件
    onGrantIdCardEndDateBtnClick() {
      this.bankCardData.grantIdCardEndDate.value = '长期';
    },
    // 收款方式点击事件
    onBankCardTypeClick() {
      if (this.bankCardData.bankCardType.mult) {
        this.$nextTick(() => {
          this.popup.type = 1;
          this.popup.title = '选择收款方式';
          this.popup.parent = 'bankCardType';
          this.popup.visible = true;
        });
      }
    },
    // 协议类型点击事件
    onAgreementTypeClick() {
      if (this.routeQueryId) return;
      if (!this.commitmentData.agreementType.mult) return;
      if (this.commitmentData.agreementType.mult) {
        this.popup.type = 1;
        this.popup.title = '选择协议类型';
        this.popup.parent = 'agreementType';
      }
      this.$nextTick(() => {
        this.popup.visible = true;
      });
    },
    //  营业周期点击事件
    onBusinessCycleClick() {
      if (this.bankCardData.businessCycle.mult) {
        return;
      }
    },
    // 所属行业点击事件
    onTradeTypeClick() {
      this.$nextTick(() => {
        this.popup.title = '所属行业分类';
        this.popup.parent = 'tradeType';
        this.popup.visible = true;
        this.popup.type = 2;
        this.popup.searchKey = '';
        this.popup.searchSubKey = '';
        this.setPopupSearchBarHandler();
        if (localStorage.getItem('pos_global_business_list')) {
          // 2022.7.19 添加用pop()删除数组中最后这个时间戳的元素
          const tmpList = JSON.parse(localStorage.getItem('pos_global_business_list'));
          tmpList.pop();
          this.popup.businessAllArr = [];
          this.popup.businessAllArr = tmpList;
          this.popup.businessOpened = [];
          this.popup.businessAllArr.map(item => this.popup.businessOpened.push(item.itemName));
        }
      });
    },
    // 所在省份城市地区点击事件
    onCompanyProvinceCItyAreaClick() {
      this.tmp.isAreaFinish = false;
      this.areaPop.visible = true;
    },
    // 所属银行点击事件
    onBankNameClick() {
      this.popup.title = '所属银行';
      this.popup.parent = 'bankName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.bankNameArr = [];
      this.setPopupSearchBarHandler();
      this.getBankNameListByType('normal', this.bankCardData.bankName.value);
    },
    // 被授权银行卡所属银行点击事件
    onGrantBankNameClick() {
      this.popup.title = '所属银行';
      this.popup.parent = 'grantBankName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.grantBankNameArr = [];
      this.setPopupSearchBarHandler();
      this.getBankNameListByType('grant', this.bankCardData.grantBankName.value);
    },
    // 所属银行开户地区点击事件
    onBankAreaClick() {
      if (this.bankCardData.bankName.value === '请选择') {
        CusToast('请先选择所属银行');
        return;
      }
      this.popup.title = '开户地区';
      this.popup.parent = 'bankArea';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankAreaArr = [];
      this.setPopupSearchBarHandler();
      this.getBankProvinceName('normal', this.bankCardData.bankName.value, this.bankCardData.bankArea.value.split(' ')[0]);
    },
    // 被授权银行卡所属银行开户地区点击事件
    onGrantBankAreaClick() {
      if (this.bankCardData.grantBankName.value === '请选择') {
        CusToast('请先选择所属银行');
        return;
      }
      this.popup.title = '开户地区';
      this.popup.parent = 'grantBankArea';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.bankAreaArr = [];
      this.setPopupSearchBarHandler();
      this.getBankProvinceName('grant', this.bankCardData.grantBankName.value, this.bankCardData.grantBankArea.value.split(' ')[0]);
    },
    // 所属银行开户支行点击事件
    onBankSubNameClick() {
      if (!this.bankCardData.bankName.value) {
        CusToast('请先选择所属银行');
        return;
      }
      const cityArr = this.bankCardData.bankArea.value.split(' ');
      if (!cityArr[0] || !cityArr[1]) {
        CusToast('请先选择开户地区');
        return;
      }
      this.popup.title = '开户行';
      this.popup.parent = 'bankSubName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankSubNameArr = [];
      this.setPopupSearchBarHandler();
      this.getBankName('normal', this.bankCardData.bankName.value, cityArr[0], cityArr[1], this.bankCardData.bankSubName.value);
    },
    // 被授权银行卡所属银行开户支行点击事件
    onGrantBankSubNameClick() {
      if (!this.bankCardData.grantBankName.value) {
        CusToast('请先选择所属银行');
        return;
      }
      const cityArr = this.bankCardData.grantBankArea.value.split(' ');
      if (!cityArr[0] || !cityArr[1]) {
        CusToast('请先选择开户地区');
        return;
      }
      this.popup.title = '开户行';
      this.popup.parent = 'grantBankSubName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.grantBankSubNameArr = [];
      this.setPopupSearchBarHandler();
      this.getBankName('grant', this.bankCardData.grantBankName.value, cityArr[0], cityArr[1], this.bankCardData.grantBankSubName.value);
    },
    // 设置费率页面点击提交事件
    onRatePageSubmitClick() {
      this.$nextTick(() => {
        if (this.tmp.getRateCodeErrMsg) {
          CusToast(this.tmp.getRateCodeErrMsg);
          return;
        }
        this.validatePageData(0, () => {
          // 设置page的完成状态
          this.tabStatus.completed[0] = true;
          // 设置page的编辑状态
          this.tabStatus.edited[1] = true;
          // 设置topbar选中样式
          this.setTabSelectedStatus(1);
        });
      });
    },
    // 公司资料页面点击提交事件
    onCompanyPageSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(1, () => {
          // 设置page的完成状态
          this.tabStatus.completed[1] = true;
          // 设置page的编辑状态
          this.tabStatus.edited[2] = true;
          // 设置topbar选中样式
          this.setTabSelectedStatus(2);
        });
      });
    },
    // 法人资料页面点击提交事件
    onCorporationPageSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(2, () => {
          // 设置page的完成状态
          this.tabStatus.completed[2] = true;
          // 设置page的编辑状态
          this.tabStatus.edited[3] = true;
          // 设置topbar选中样式
          this.setTabSelectedStatus(3);
          this.bankCardData.accountName.value = this.corporationData.corporationName.value;
        });
      });
    },
    // 收款资料页面点击提交事件
    onBankCardPageSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(3, () => {
          const number = this.bankCardData.bankCardNumber.value.replace(/\s/gi, '');
          this.getSBNOByCardNumForBtn(number, () => {
            // 设置page的完成状态
            this.tabStatus.completed[3] = true;
            // 设置page的编辑状态
            this.tabStatus.edited[4] = true;
            // 设置topbar选中样式
            this.setTabSelectedStatus(4);
          });
        });
      });
    },
    // 授权协议点击提交事件
    onCommitmentPageSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(4, () => {
          // 设置page的完成状态
          this.tabStatus.completed[4] = true;
          if (!this.routeQueryId) {
            if (this.currentIntoType === 0) {
              this.insertNewCustomerData();
            } else {
              this.insertNewXiaoWeiCustomerData();
            }
          } else {
            if (this.currentIntoType === 0) {
              this.editCustomerData();
            } else {
              this.editXiaoWeiCustomerData();
            }
          }
        });
      });
    },
    // 完成页面的完成按钮点击事件
    onFlowFinishBtnClick() {
      if (this.flow.finished === true) {
        if (this.flow.type === 'add') {
          this.$router.go(-1);
        } else if (this.flow.type === 'edit') {
          this.$router.go(-2);
        } else {
          this.$router.go(-1);
        }
      }
    },
    // 完成页面的启动协议按钮点击事件
    onAgreementFlowStartBtnClick() {
      ResendEAgreement({ _id: this.agreement.id })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data === 4) {
                CusAlert('协议发起成功，请及时查阅并签署协议', () => {
                  this.$router.go(-1);
                });
              } else {
                CusAlert('发起失败，请再次点击按钮，重新发起协议流程');
              }
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.tmp.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // popup 窗口返回单击事件
    onPopupBackBtnClick() {
      this.popup.visible = false;
      // 2022.6.22 添加移除长备选项页面的查询组件中的按钮事件
      if (this.popup.searchBar.input) this.popup.searchBar.input.removeEventListener('input', this.customSearchBarInputEvent);
      if (this.popup.searchBar.cancel) this.popup.searchBar.cancel.removeEventListener('click', this.customSearchBarClickEvent);
      if (this.popup.searchSubBar.input) this.popup.searchSubBar.input.removeEventListener('input', this.customSearchSubBarInputEvent);
      if (this.popup.searchSubBar.cancel) this.popup.searchSubBar.cancel.removeEventListener('click', this.customSearchSubBarClickEvent);
    },
    // 营业执照类型的单击事件
    onBusinessLicenseTypeItemClick(item) {
      this.popup.businessLicenseTypeArr.forEach(item => (item.selected = false));
      item.selected = true;
    },
    // 收款方式备选项的单击事件
    onBankCardTypeItemClick(item) {
      this.popup.bankCardTypeArr.forEach(item => (item.selected = false));
      item.selected = true;
    },
    // 协议类型备选选的单击事件
    onAgreementTypeItemClick(item) {
      this.popup.agreementTypeArr.forEach(item => (item.selected = false));
      item.selected = true;
    },
    // 行业类别分类的子项备选项的单击事件
    onPopupSubTradeTypeItemClick(item) {
      if (this.popup.type === 2) {
        this.companyData.tradeType.value = item.businessName;
        this.companyData.tradeType.id = item.businessId;
        this.popup.visible = false;
      }
    },
    // 所属银行备选项的单击事件
    onPopupBankNameItemClick(item) {
      this.popup.bankNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.bankCardData.bankName.value = item.label;
        this.bankCardData.bankArea.value = '请选择';
        this.bankCardData.bankSubName.value = '请选择';
        this.bankCardData.bankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // 所属银行地区备选项的单击事件
    onPopupBankAreaItemClick(item) {
      this.popup.bankAreaArr.forEach(item => (item.selected = false));
      item.selected = true;
      this.popup.type = 3;
      this.popup.title = '开户地区';
      this.popup.parent = 'bankAreaProvince';
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankAreaCityArr = [];
      this.tmp.bankAreaCity = item.label;
      this.setPopupSearchSubBarHandler();
      this.getBankCityName('normal', this.bankCardData.bankName.value, item.label, this.bankCardData.bankArea.value.split(' ')[1]);
    },
    // 所属银行地区城市备选项的单击事件
    onPopupBankAreaCityItemClick(item) {
      this.popup.bankAreaCityArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 3) {
        this.bankCardData.bankArea.value = `${this.tmp.bankAreaCity} ${item.label}`;
        this.bankCardData.bankSubName.value = '请选择';
        this.bankCardData.bankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // 所属银行开户行备选项的单击事件
    onPopupBankSubNameItemClick(item) {
      this.popup.bankSubNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.bankCardData.bankSubName.value = item.label;
        this.bankCardData.bankSubName.sbno = item.value;
        this.popup.visible = false;
      }
    },
    // 被授权人所属银行备选项的单击事件
    onPopupGrantBankNameItemClick(item) {
      this.popup.grantBankNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.bankCardData.grantBankName.value = item.label;
        this.bankCardData.grantBankArea.value = '请选择';
        this.bankCardData.grantBankSubName.value = '请选择';
        this.bankCardData.grantBankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // 被授权人所属银行地区备选项的单击事件
    onPopupGrantBankAreaItemClick(item) {
      this.popup.bankAreaArr.forEach(item => (item.selected = false));
      item.selected = true;
      this.popup.type = 3;
      this.popup.title = '开户地区';
      this.popup.parent = 'grantBankAreaProvince';
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.grantBankAreaCityArr = [];
      this.tmp.grantBankAreaCity = item.label;
      this.setPopupSearchSubBarHandler();
      this.getBankCityName('grant', this.bankCardData.grantBankName.value, item.label, this.bankCardData.grantBankArea.value.split(' ')[1]);
    },
    // 被授权人所属银行地区城市备选项的单击事件
    onPopupGrantBankAreaCityItemClick(item) {
      this.popup.bankAreaCityArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 3) {
        this.bankCardData.grantBankArea.value = `${this.tmp.grantBankAreaCity} ${item.label}`;
        this.bankCardData.grantBankSubName.value = '请选择';
        this.bankCardData.grantBankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // 被授权人所属银行开户行备选项的单击事件
    onPopupGrantBankSubNameItemClick(item) {
      this.popup.bankSubNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.bankCardData.grantBankSubName.value = item.label;
        this.bankCardData.grantBankSubName.sbno = item.value;
        this.popup.visible = false;
      }
    },
    // 选中确定成功的单击事件
    onPopupSuccessBtnClick() {
      if (this.popup.parent === 'businessLicenseType') {
        for (let i = 0; i < this.popup.businessLicenseTypeArr.length; i++) {
          if (this.popup.businessLicenseTypeArr[i].selected) {
            this.companyData.businessLicenseType.value = this.popup.businessLicenseTypeArr[i].label;
            this.companyData.businessLicenseType.id = this.popup.businessLicenseTypeArr[i].value;
            break;
          }
        }
      }
      if (this.popup.parent === 'bankCardType') {
        for (let i = 0; i < this.popup.bankCardTypeArr.length; i++) {
          if (this.popup.bankCardTypeArr[i].selected) {
            this.bankCardData.bankCardType.value = this.popup.bankCardTypeArr[i].label;
            this.bankCardData.bankCardType.id = this.popup.bankCardTypeArr[i].value;
            break;
          }
        }
      }
      if (this.popup.parent === 'agreementType') {
        for (let i = 0; i < this.popup.agreementTypeArr.length; i++) {
          if (this.popup.agreementTypeArr[i].selected) {
            this.commitmentData.agreementType.value = this.popup.agreementTypeArr[i].label;
            this.commitmentData.agreementType.id = this.popup.agreementTypeArr[i].value;
            break;
          }
        }
        if (this.commitmentData.agreementType.id === 0) {
          this.commitmentData.commitmentNumber.value = '';
        } else {
          this.generateAuthNum(() => {
            this.commitmentData.commitmentNumber.value = this.tmp.commitmentNumber;
          });
        }
      }
      this.$nextTick(() => {
        this.popup.visible = false;
      });
    },
    // 备选项弹窗的查询keyup事件
    onPopupSearchKeyup() {
      switch (this.popup.parent) {
        case 'tradeType':
          for (let i = 0; i < this.popup.businessAllArr.length; i++) {
            this.popup.businessAllArr[i].subBusinessArr = this.popup.businessAllArr[i].subBusinessArr.filter(item => {
              return item.businessLabel.indexOf(this.popup.searchKey) > -1;
            });
          }
          break;
        case 'bankName':
          this.popup.bankNameArr = this.popup.bankNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'bankArea':
          this.popup.bankAreaArr = this.popup.bankAreaArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'bankSubName':
          this.popup.bankSubNameArr = this.popup.bankSubNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'grantBankName':
          this.popup.grantBankNameArr = this.popup.grantBankNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'grantBankArea':
          this.popup.grantBankAreaArr = this.popup.grantBankAreaArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'grantBankSubName':
          this.popup.grantBankSubNameArr = this.popup.grantBankSubNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
      }
      document.activeElement.blur();
    },
    // 备选项二级弹窗的查询keyup事件
    onPopupSearchSubKeyup() {
      switch (this.popup.parent) {
        case 'bankAreaProvince':
          this.popup.bankAreaCityArr = this.popup.bankAreaCityArr.filter(item => {
            return item.label.indexOf(this.popup.searchSubKey) > -1;
          });
          break;
        case 'grantBankAreaProvince':
          this.popup.grantBankAreaCityArr = this.popup.grantBankAreaCityArr.filter(item => {
            return item.label.indexOf(this.popup.searchSubKey) > -1;
          });
          break;
      }
      document.activeElement.blur();
    },
    // 日期控件确定
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      if (this.picker.parent === 'licenceStartDate') {
        this.companyData.licenceStartDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'licenseValidDate') {
        this.companyData.licenseValidDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'identityCardStartDate') {
        this.corporationData.identityCardStartDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'identityCardEndDate') {
        this.corporationData.identityCardEndDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'grantIdCardStartDate') {
        this.bankCardData.grantIdCardStartDate.value = formatDateId(val);
      }
      if (this.picker.parent === 'grantIdCardEndDate') {
        this.bankCardData.grantIdCardEndDate.value = formatDateId(val);
      }
    },
    // 地区选择控件选中事件
    onAreaPopChange(picker) {
      this.$nextTick(() => {
        this.tmp.selectedCompanyProvince.id = picker.getSlotValue(0) ? picker.getSlotValue(0).value : '';
        this.tmp.selectedCompanyProvince.value = picker.getSlotValue(0) ? picker.getSlotValue(0).label : '';
        this.tmp.selectedCompanyCity.id = picker.getSlotValue(1) ? picker.getSlotValue(1).value : '';
        this.tmp.selectedCompanyCity.value = picker.getSlotValue(1) ? picker.getSlotValue(1).label : '';
        this.tmp.selectedCompanyArea.id = picker.getSlotValue(2) ? picker.getSlotValue(2).value : '';
        this.tmp.selectedCompanyArea.value = picker.getSlotValue(2) ? picker.getSlotValue(2).label : '';
      });
    },
    // 地区选择控件确定按钮事件
    onAreaPopupSuccessClick() {
      if (this.tmp.isAreaFinish) {
        this.companyData.companyProvince.id = this.tmp.selectedCompanyProvince.id;
        this.companyData.companyProvince.value = this.tmp.selectedCompanyProvince.value;
        this.companyData.companyCity.id = this.tmp.selectedCompanyCity.id;
        this.companyData.companyCity.value = this.tmp.selectedCompanyCity.value;
        this.companyData.companyArea.id = this.tmp.selectedCompanyArea.id;
        this.companyData.companyArea.value = this.tmp.selectedCompanyArea.value;
        this.areaPop.visible = false;
      }
    },
    // 文字拷贝成功事件
    onClipboardSuccess() {
      CusToast('复制成功');
    },
    // 文字拷贝失败事件
    onClipboardError() {
      CusToast('复制失败');
    },
  },
};
</script>

<style scoped>
.rate-text {
  text-align: right;
  padding-right: 0.6rem !important;
}
</style>
